import dayjs from 'dayjs';

export class MockedVitocal250AFeatures {
  mock(installationId: number, gatewaySerial: string) {
    return [
      {
        properties: {
          hoursUnit: {
            value: 'hour',
            type: 'string',
          },
          hours: {
            type: 'number',
            value: 0,
            unit: 'hour',
          },
          starts: {
            type: 'number',
            value: 0,
            unit: '',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/ventilation/features/ventilation.preHeater.statistics',
        gatewayId: gatewaySerial,
        feature: 'ventilation.preHeater.statistics',
        timestamp: '2022-04-08T16:35:02.453Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'ventilation',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 0,
            unit: 'hour',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/ventilation/features/ventilation.fan.exhaust.runtime',
        gatewayId: gatewaySerial,
        feature: 'ventilation.fan.exhaust.runtime',
        timestamp: '2022-04-08T16:35:02.436Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'ventilation',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 0,
            unit: 'celsius',
          },
          status: {
            type: 'string',
            value: 'connected',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/ventilation/features/ventilation.sensors.temperature.exhaust',
        gatewayId: gatewaySerial,
        feature: 'ventilation.sensors.temperature.exhaust',
        timestamp: '2022-04-08T16:35:02.458Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'ventilation',
      },
      {
        properties: {
          serviceIntervalMonths: {
            value: 3,
            unit: '',
            type: 'number',
          },
          serviceDue: {
            value: false,
            type: 'boolean',
          },
          nextService: {
            value: '2022-01-01',
            type: 'string',
          },
        },
        commands: {
          confirmService: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.service.timeBased/commands/confirmService',
            name: 'confirmService',
            isExecutable: false,
            params: {},
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/ventilation/features/heating.service.timeBased',
        gatewayId: gatewaySerial,
        feature: 'heating.service.timeBased',
        timestamp: '2022-04-06T20:44:03.811Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'ventilation',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 0,
            unit: 'partsPerMinute',
          },
          status: {
            type: 'string',
            value: 'connected',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/ventilation/features/ventilation.airQuality.fineDust.current',
        gatewayId: gatewaySerial,
        feature: 'ventilation.airQuality.fineDust.current',
        timestamp: '2022-04-08T16:35:02.351Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'ventilation',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 0,
            unit: 'partsPerMinute',
          },
          status: {
            type: 'string',
            value: 'connected',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/ventilation/features/ventilation.airQuality.dust.current',
        gatewayId: gatewaySerial,
        feature: 'ventilation.airQuality.dust.current',
        timestamp: '2022-04-08T16:35:02.359Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'ventilation',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 0,
            unit: 'celsius',
          },
          status: {
            type: 'string',
            value: 'connected',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/ventilation/features/ventilation.sensors.temperature.extract',
        gatewayId: gatewaySerial,
        feature: 'ventilation.sensors.temperature.extract',
        timestamp: '2022-04-08T16:35:02.457Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'ventilation',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/ventilation/features/ventilation.operating.programs.automatic',
        gatewayId: gatewaySerial,
        feature: 'ventilation.operating.programs.automatic',
        timestamp: '2022-04-08T16:35:02.460Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'ventilation',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: true,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/ventilation/features/ventilation.preHeater',
        gatewayId: gatewaySerial,
        feature: 'ventilation.preHeater',
        timestamp: '2022-04-08T16:35:02.454Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'ventilation',
      },
      {
        properties: {
          value: {
            value: 'ventilation',
            type: 'string',
          },
        },
        commands: {
          setMode: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/ventilation.operating.modes.active/commands/setMode',
            name: 'setMode',
            isExecutable: true,
            params: {
              mode: {
                type: 'string',
                required: true,
                constraints: {
                  enum: ['permanent', 'ventilation', 'sensorOverride', 'sensorDriven'],
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/ventilation/features/ventilation.operating.modes.active',
        gatewayId: gatewaySerial,
        feature: 'ventilation.operating.modes.active',
        timestamp: '2022-04-06T20:44:04.837Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'ventilation',
      },
      {
        properties: {
          entries: {
            type: 'array',
            value: [],
            unit: '',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/ventilation/features/device.messages.status.raw',
        gatewayId: gatewaySerial,
        feature: 'device.messages.status.raw',
        timestamp: '2022-04-08T16:35:02.442Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'ventilation',
      },
      {
        properties: {
          entries: {
            type: 'ErrorListChanges',
            constraints: {},
            value: {
              new: [],
              current: [],
              gone: [],
            },
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/ventilation/features/device.messages.status.active',
        gatewayId: gatewaySerial,
        feature: 'device.messages.status.active',
        timestamp: '2022-04-06T20:44:03.780Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'ventilation',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/ventilation/features/ventilation.bypass.operating.modes.off',
        gatewayId: gatewaySerial,
        feature: 'ventilation.bypass.operating.modes.off',
        timestamp: '2022-04-08T16:37:02.251Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'ventilation',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
          unit: {
            value: 'cubicMeter/hour',
            type: 'string',
          },
          volumeFlow: {
            type: 'number',
            value: 257,
            unit: 'cubicMeter/hour',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/ventilation/features/ventilation.operating.programs.levelOne',
        gatewayId: gatewaySerial,
        feature: 'ventilation.operating.programs.levelOne',
        timestamp: '2022-04-08T16:35:02.414Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'ventilation',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          remainingRuntime: {
            value: 0,
            unit: 'minutes',
            type: 'number',
          },
          defaultRuntime: {
            value: 30,
            unit: 'minutes',
            type: 'number',
          },
        },
        commands: {
          activate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/ventilation.operating.programs.forcedLevelFour/commands/activate',
            name: 'activate',
            isExecutable: true,
            params: {
              timeout: {
                type: 'number',
                required: false,
                constraints: {
                  min: 1,
                  max: 1440,
                  stepping: 1,
                },
              },
            },
          },
          deactivate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/ventilation.operating.programs.forcedLevelFour/commands/deactivate',
            name: 'deactivate',
            isExecutable: false,
            params: {},
          },
          setTimeout: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/ventilation.operating.programs.forcedLevelFour/commands/setTimeout',
            name: 'setTimeout',
            isExecutable: true,
            params: {
              timeout: {
                type: 'number',
                required: true,
                constraints: {
                  min: 1,
                  max: 1440,
                  stepping: 1,
                },
              },
            },
          },
          setDefaultRuntime: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/ventilation.operating.programs.forcedLevelFour/commands/setDefaultRuntime',
            name: 'setDefaultRuntime',
            isExecutable: true,
            params: {
              defaultRuntime: {
                type: 'number',
                required: true,
                constraints: {
                  min: 1,
                  max: 1440,
                  stepping: 1,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/ventilation/features/ventilation.operating.programs.forcedLevelFour',
        gatewayId: gatewaySerial,
        feature: 'ventilation.operating.programs.forcedLevelFour',
        timestamp: '2022-10-09T10:36:17.479Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'ventilation',
      },
      {
        properties: {
          value: {
            value: 'automaticDynamicRegulation',
            type: 'string',
          },
          state: {
            value: 'automatic',
            type: 'string',
          },
          level: {
            value: 'dynamicRegulationMode',
            type: 'string',
          },
        },
        commands: {
          setMode: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/ventilation.bypass.operating.modes.active/commands/setMode',
            name: 'setMode',
            isExecutable: true,
            params: {
              mode: {
                type: 'string',
                required: true,
                constraints: {
                  enum: ['off', 'automaticSmoothRegulation', 'automaticDynamicRegulation'],
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/ventilation/features/ventilation.bypass.operating.modes.active',
        gatewayId: gatewaySerial,
        feature: 'ventilation.bypass.operating.modes.active',
        timestamp: '2022-04-08T16:37:02.250Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'ventilation',
      },
      {
        feature: 'ventilation.bypass.configuration.temperature.perceived',
        deviceId: 'ventilation',
        gatewayId: gatewaySerial,
        apiVersion: 1,
        isEnabled: true,
        isReady: true,
        timestamp: '2020-02-02T20:00:00.000Z',
        properties: {
          value: {
            value: 22,
            type: 'number',
            unit: 'celsius',
          },
        },
        commands: {
          setTargetTemperature: {
            name: 'setTargetTemperature',
            isExecutable: true,
            params: {
              temperature: {
                type: 'number',
                constraints: {
                  min: 3,
                  max: 37,
                  stepping: 1,
                },
                required: true,
                description: 'Target temperature',
              },
            },
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/ventilation/features/ventilation.bypass.configuration.temperature.perceived/commands/setTargetTemperature',
          },
        },
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/ventilation/features/ventilation.bypass.configuration.temperature.perceived',
        description:
          'Shows the perceived temperature for bypass mode. Also provides command to set it.',
      },
      {
        feature: 'ventilation.bypass.configuration.temperature.supply',
        deviceId: 'ventilation',
        gatewayId: gatewaySerial,
        apiVersion: 1,
        isEnabled: true,
        isReady: true,
        timestamp: '2020-02-02T20:00:00.000Z',
        properties: {
          value: {
            value: 22,
            type: 'number',
            unit: 'celsius',
          },
        },
        commands: {
          setTargetTemperature: {
            name: 'setTargetTemperature',
            isExecutable: true,
            params: {
              temperature: {
                type: 'number',
                constraints: {
                  min: 3,
                  max: 37,
                  stepping: 1,
                },
                required: true,
                description: 'Target temperature',
              },
            },
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/ventilation/features/ventilation.bypass.configuration.temperature.supply/commands/setTargetTemperature',
          },
        },
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/ventilation/features/ventilation.bypass.configuration.temperature.supply',
        description:
          'Shows the supply temperature for bypass mode. Also provides command to set it.',
      },
      {
        properties: {
          unit: {
            value: 'percent',
            type: 'string',
          },
          input: {
            type: 'number',
            value: 6.8,
            unit: 'percent',
          },
          output: {
            type: 'number',
            value: -8.6,
            unit: 'percent',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/ventilation/features/ventilation.air.balance.offset',
        gatewayId: gatewaySerial,
        feature: 'ventilation.air.balance.offset',
        timestamp: '2022-04-08T16:35:02.383Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'ventilation',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: true,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/ventilation/features/ventilation.bypass',
        gatewayId: gatewaySerial,
        feature: 'ventilation.bypass',
        timestamp: '2022-04-08T16:35:02.373Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'ventilation',
      },
      {
        properties: {
          entries: {
            type: 'ErrorListChanges',
            constraints: {},
            value: {
              new: [],
              current: [
                {
                  priority: 'criticalError',
                  timestamp: '2022-04-06T20:44:03.754Z',
                  accessLevel: 'customer',
                  errorCode: 'F.785',
                  audiences: [
                    'IS-SUPPLIER',
                    'IS-DEVELOPMENT',
                    'IS-MANUFACTURING',
                    'IS-AFTERSALES',
                    'IS-AFTERMARKET',
                    'IS-DEVELOPER-VEG',
                    'IS-BIG-DATA',
                    'IS-MANUFACTURING-VEG',
                  ],
                },
                {
                  priority: 'criticalError',
                  timestamp: '2022-04-06T20:44:03.754Z',
                  accessLevel: 'customer',
                  errorCode: 'F.160',
                  audiences: [
                    'IS-SUPPLIER',
                    'IS-DEVELOPMENT',
                    'IS-MANUFACTURING',
                    'IS-AFTERSALES',
                    'IS-AFTERMARKET',
                    'IS-DEVELOPER-VEG',
                    'IS-BIG-DATA',
                    'IS-MANUFACTURING-VEG',
                  ],
                },
              ],
              gone: [],
            },
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/ventilation/features/device.errors.active',
        gatewayId: gatewaySerial,
        feature: 'device.errors.active',
        timestamp: '2022-04-06T20:55:27.917Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'ventilation',
      },
      {
        properties: {
          status: {
            type: 'string',
            value: 'notConnected',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/ventilation/features/ventilation.sensors.temperature.supply',
        gatewayId: gatewaySerial,
        feature: 'ventilation.sensors.temperature.supply',
        timestamp: '2022-04-08T16:35:02.402Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'ventilation',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: true,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/ventilation/features/ventilation',
        gatewayId: gatewaySerial,
        feature: 'ventilation',
        timestamp: '2022-04-08T16:35:02.371Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'ventilation',
      },
      {
        properties: {
          value: {
            type: 'array',
            value: [
              {
                busAddress: 1,
                busType: 'CanInternal',
                deviceObjectProperty: 'VCUMaster',
                deviceFunction: 'Nothing',
                softwareVersion: '0016.0300.2123.0080',
                hardwareVersion: '0000.0000.0000.0000',
                etn: '9999999�99999���',
              },
              {
                busAddress: 58,
                busType: 'InternalUart',
                deviceObjectProperty: 'BackendGateway',
                deviceFunction: 'Nothing',
                softwareVersion: '0041.0402.2119.0027',
                hardwareVersion: '0041.0001.0000.0000',
                etn: '7949720000016212',
              },
            ],
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/ventilation/features/device.busTopology',
        gatewayId: gatewaySerial,
        feature: 'device.busTopology',
        timestamp: '2022-04-08T16:35:02.472Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'ventilation',
      },
      {
        properties: {
          unit: {
            value: 'percent',
            type: 'string',
          },
          value: {
            type: 'number',
            value: 0,
            unit: 'percent',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/ventilation/features/ventilation.bypass.position',
        gatewayId: gatewaySerial,
        feature: 'ventilation.bypass.position',
        timestamp: '2022-04-08T16:35:02.393Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'ventilation',
      },
      {
        properties: {
          status: {
            type: 'string',
            value: 'connected',
          },
          minValue: {
            type: 'number',
            value: 0,
            unit: 'partsPerMinute',
          },
          maxValue: {
            type: 'number',
            value: 0,
            unit: 'partsPerMinute',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/ventilation/features/ventilation.airQuality.humidity.current',
        gatewayId: gatewaySerial,
        feature: 'ventilation.airQuality.humidity.current',
        timestamp: '2022-04-08T16:35:02.424Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'ventilation',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 0,
            unit: 'partsPerMinute',
          },
          status: {
            type: 'string',
            value: 'connected',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/ventilation/features/ventilation.airQuality.co2.current',
        gatewayId: gatewaySerial,
        feature: 'ventilation.airQuality.co2.current',
        timestamp: '2022-04-08T16:35:02.401Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'ventilation',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
          unit: {
            value: 'cubicMeter/hour',
            type: 'string',
          },
          volumeFlow: {
            type: 'number',
            value: 257,
            unit: 'cubicMeter/hour',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/ventilation/features/ventilation.operating.programs.levelTwo',
        gatewayId: gatewaySerial,
        feature: 'ventilation.operating.programs.levelTwo',
        timestamp: '2022-04-08T16:35:02.421Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'ventilation',
      },
      {
        properties: {
          entries: {
            type: 'array',
            value: [],
            unit: '',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/ventilation/features/device.messages.info.raw',
        gatewayId: gatewaySerial,
        feature: 'device.messages.info.raw',
        timestamp: '2022-04-08T16:35:02.441Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'ventilation',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/ventilation/features/ventilation.operating.modes.sensorOverride',
        gatewayId: gatewaySerial,
        feature: 'ventilation.operating.modes.sensorOverride',
        timestamp: '2022-04-08T16:35:02.449Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'ventilation',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/ventilation/features/ventilation.operating.modes.filterChange',
        gatewayId: gatewaySerial,
        feature: 'ventilation.operating.modes.filterChange',
        timestamp: '2022-04-08T16:35:02.459Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'ventilation',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 0,
            unit: 'partsPerMinute',
          },
          status: {
            type: 'string',
            value: 'connected',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/ventilation/features/ventilation.airQuality.co.current',
        gatewayId: gatewaySerial,
        feature: 'ventilation.airQuality.co.current',
        timestamp: '2022-04-08T16:35:02.411Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'ventilation',
      },
      {
        properties: {
          entries: {
            type: 'ErrorListChanges',
            constraints: {},
            value: {
              new: [],
              current: [],
              gone: [],
            },
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/ventilation/features/device.messages.warnings.active',
        gatewayId: gatewaySerial,
        feature: 'device.messages.warnings.active',
        timestamp: '2022-04-06T20:44:03.770Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'ventilation',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: true,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/ventilation/features/ventilation.operating.modes.ventilation',
        gatewayId: gatewaySerial,
        feature: 'ventilation.operating.modes.ventilation',
        timestamp: '2022-04-08T16:35:02.448Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'ventilation',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 4096,
            unit: 'cubicMeter/hour',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/ventilation/features/ventilation.volumeFlow.current.output',
        gatewayId: gatewaySerial,
        feature: 'ventilation.volumeFlow.current.output',
        timestamp: '2022-04-08T16:35:02.456Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'ventilation',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
          unit: {
            value: 'cubicMeter/hour',
            type: 'string',
          },
          volumeFlow: {
            type: 'number',
            value: 257,
            unit: 'cubicMeter/hour',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/ventilation/features/ventilation.operating.programs.levelThree',
        gatewayId: gatewaySerial,
        feature: 'ventilation.operating.programs.levelThree',
        timestamp: '2022-04-08T16:35:02.422Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'ventilation',
      },
      {
        properties: {
          latitudeUnit: {
            value: 'degree',
            type: 'string',
          },
          latitude: {
            type: 'number',
            value: 0,
            unit: 'degree',
          },
          longitudeUnit: {
            value: 'degree',
            type: 'string',
          },
          longitude: {
            type: 'number',
            value: 0,
            unit: 'degree',
          },
          altitudeUnit: {
            value: 'meter',
            type: 'string',
          },
          altitude: {
            type: 'number',
            value: 0,
            unit: 'meter',
          },
        },
        commands: {
          setLocation: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.configuration.houseLocation/commands/setLocation',
            name: 'setLocation',
            isExecutable: true,
            params: {
              latitude: {
                required: true,
                constraints: {
                  min: -90,
                  max: 90,
                  stepping: 0.0001,
                },
                type: 'number',
              },
              longitude: {
                required: true,
                constraints: {
                  min: -180,
                  max: 180,
                  stepping: 0.0001,
                },
                type: 'number',
              },
              altitude: {
                required: true,
                constraints: {
                  min: 0,
                  max: 8848,
                  stepping: 1,
                },
                type: 'number',
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/ventilation/features/heating.configuration.houseLocation',
        gatewayId: gatewaySerial,
        feature: 'heating.configuration.houseLocation',
        timestamp: '2022-04-08T16:35:02.367Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'ventilation',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/ventilation/features/ventilation.operating.modes.sensorDriven',
        gatewayId: gatewaySerial,
        feature: 'ventilation.operating.modes.sensorDriven',
        timestamp: '2022-04-08T16:35:02.450Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'ventilation',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
          entries: {
            value: {
              mon: [],
              tue: [],
              wed: [],
              thu: [],
              fri: [],
              sat: [],
              sun: [],
            },
            type: 'Schedule',
          },
        },
        commands: {
          setSchedule: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/ventilation.schedule/commands/setSchedule',
            name: 'setSchedule',
            isExecutable: true,
            params: {
              newSchedule: {
                type: 'Schedule',
                required: true,
                constraints: {
                  modes: ['levelTwo', 'levelThree'],
                  maxEntries: 4,
                  resolution: 10,
                  defaultMode: 'levelOne',
                  overlapAllowed: false,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/ventilation/features/ventilation.schedule',
        gatewayId: gatewaySerial,
        feature: 'ventilation.schedule',
        timestamp: '2022-04-06T20:44:04.807Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'ventilation',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
          unit: {
            value: 'cubicMeter/hour',
            type: 'string',
          },
          volumeFlow: {
            type: 'number',
            value: 257,
            unit: 'cubicMeter/hour',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/ventilation/features/ventilation.operating.programs.levelFour',
        gatewayId: gatewaySerial,
        feature: 'ventilation.operating.programs.levelFour',
        timestamp: '2022-04-08T16:35:02.425Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'ventilation',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 400,
            unit: 'partsPerMinute',
          },
          status: {
            type: 'string',
            value: 'connected',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/ventilation/features/ventilation.airQuality.organicComponents.current',
        gatewayId: gatewaySerial,
        feature: 'ventilation.airQuality.organicComponents.current',
        timestamp: '2022-04-08T16:35:02.400Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'ventilation',
      },
      {
        properties: {
          status: {
            type: 'string',
            value: 'on',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/ventilation/features/ventilation.heatExchanger.frostprotection',
        gatewayId: gatewaySerial,
        feature: 'ventilation.heatExchanger.frostprotection',
        timestamp: '2022-04-08T16:35:02.397Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'ventilation',
      },
      {
        properties: {
          unit: {
            value: 'hours',
            type: 'string',
          },
          operatingHours: {
            type: 'number',
            value: 0,
            unit: 'hours',
          },
          remainingHours: {
            type: 'number',
            value: 0,
            unit: 'hours',
          },
          overdueHours: {
            type: 'number',
            value: 0,
            unit: 'hours',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/ventilation/features/ventilation.filter.runtime',
        gatewayId: gatewaySerial,
        feature: 'ventilation.filter.runtime',
        timestamp: '2022-04-08T16:35:02.398Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'ventilation',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/ventilation/features/ventilation.bypass.operating.modes.open',
        gatewayId: gatewaySerial,
        feature: 'ventilation.bypass.operating.modes.open',
        timestamp: '2022-04-08T16:35:02.390Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'ventilation',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 0,
            unit: 'celsius',
          },
          status: {
            type: 'string',
            value: 'connected',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/ventilation/features/ventilation.airQuality.temperature.current',
        gatewayId: gatewaySerial,
        feature: 'ventilation.airQuality.temperature.current',
        timestamp: '2022-04-08T16:35:02.399Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'ventilation',
      },
      {
        properties: {
          entries: {
            type: 'array',
            value: [
              {
                priority: 'criticalError',
                timestamp: '2021-06-28T12:08:05.000Z',
                accessLevel: 'customer',
                errorCode: 'F.160',
                audiences: [
                  'IS-SUPPLIER',
                  'IS-DEVELOPMENT',
                  'IS-MANUFACTURING',
                  'IS-AFTERSALES',
                  'IS-AFTERMARKET',
                  'IS-DEVELOPER-VEG',
                  'IS-BIG-DATA',
                  'IS-MANUFACTURING-VEG',
                ],
              },
              {
                priority: 'criticalError',
                timestamp: '2018-01-01T00:00:00.000Z',
                accessLevel: 'customer',
                errorCode: 'F.785',
                audiences: [
                  'IS-SUPPLIER',
                  'IS-DEVELOPMENT',
                  'IS-MANUFACTURING',
                  'IS-AFTERSALES',
                  'IS-AFTERMARKET',
                  'IS-DEVELOPER-VEG',
                  'IS-BIG-DATA',
                  'IS-MANUFACTURING-VEG',
                ],
              },
            ],
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/ventilation/features/device.messages.errors.raw',
        gatewayId: gatewaySerial,
        feature: 'device.messages.errors.raw',
        timestamp: '2022-04-08T16:35:02.439Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'ventilation',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: true,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/ventilation/features/ventilation.bypass.operating.modes.active',
        gatewayId: gatewaySerial,
        feature: 'ventilation.bypass.operating.modes.active',
        timestamp: '2022-04-08T16:37:02.252Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'ventilation',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {
          setLevel: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/ventilation.operating.modes.permanent/commands/setLevel',
            name: 'setLevel',
            isExecutable: true,
            params: {
              level: {
                type: 'string',
                required: true,
                constraints: {
                  enum: ['levelOne', 'levelTwo', 'levelThree', 'levelFour'],
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/ventilation/features/ventilation.operating.modes.permanent',
        gatewayId: gatewaySerial,
        feature: 'ventilation.operating.modes.permanent',
        timestamp: '2022-04-06T20:44:04.835Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'ventilation',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: true,
          },
          unit: {
            value: 'cubicMeter/hour',
            type: 'string',
          },
          volumeFlow: {
            type: 'number',
            value: 0,
            unit: 'cubicMeter/hour',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/ventilation/features/ventilation.operating.programs.standby',
        gatewayId: gatewaySerial,
        feature: 'ventilation.operating.programs.standby',
        timestamp: '2022-04-08T16:35:02.413Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'ventilation',
      },
      {
        properties: {
          value: {
            type: 'string',
            value: '9999999ª99999ªªª',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/ventilation/features/heating.boiler.serial',
        gatewayId: gatewaySerial,
        feature: 'heating.boiler.serial',
        timestamp: '2022-04-08T16:35:02.473Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'ventilation',
      },
      {
        properties: {
          entries: {
            type: 'array',
            value: [],
            unit: '',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/ventilation/features/device.messages.warnings.raw',
        gatewayId: gatewaySerial,
        feature: 'device.messages.warnings.raw',
        timestamp: '2022-04-08T16:35:02.440Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'ventilation',
      },
      {
        properties: {
          entries: {
            type: 'ErrorListChanges',
            constraints: {},
            value: {
              new: [],
              current: [],
              gone: [],
            },
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/ventilation/features/device.messages.info.active',
        gatewayId: gatewaySerial,
        feature: 'device.messages.info.active',
        timestamp: '2022-04-06T20:44:03.777Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'ventilation',
      },
      {
        properties: {
          entries: {
            type: 'ErrorListChanges',
            constraints: {},
            value: {
              new: [],
              current: [
                {
                  priority: 'service',
                  timestamp: '2022-04-06T20:44:03.790Z',
                  accessLevel: 'customer',
                  errorCode: 'P.1',
                  audiences: [
                    'IS-SUPPLIER',
                    'IS-DEVELOPMENT',
                    'IS-MANUFACTURING',
                    'IS-AFTERSALES',
                    'IS-AFTERMARKET',
                    'IS-DEVELOPER-VEG',
                    'IS-BIG-DATA',
                    'IS-MANUFACTURING-VEG',
                  ],
                },
              ],
              gone: [],
            },
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/ventilation/features/device.messages.service.active',
        gatewayId: gatewaySerial,
        feature: 'device.messages.service.active',
        timestamp: '2022-04-08T16:35:02.404Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'ventilation',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          remainingRuntime: {
            value: 0,
            unit: 'minutes',
            type: 'number',
          },
          defaultRuntime: {
            value: 30,
            unit: 'minutes',
            type: 'number',
          },
        },
        commands: {
          activate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/ventilation.operating.programs.silent/commands/activate',
            name: 'activate',
            isExecutable: true,
            params: {
              timeout: {
                type: 'number',
                required: false,
                constraints: {
                  min: 1,
                  max: 1440,
                  stepping: 1,
                },
              },
            },
          },
          deactivate: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/ventilation.operating.programs.silent/commands/deactivate',
            name: 'deactivate',
            isExecutable: false,
            params: {},
          },
          setTimeout: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/ventilation.operating.programs.silent/commands/setTimeout',
            name: 'setTimeout',
            isExecutable: true,
            params: {
              timeout: {
                type: 'number',
                required: true,
                constraints: {
                  min: 1,
                  max: 1440,
                  stepping: 1,
                },
              },
            },
          },
          setDefaultRuntime: {
            uri:
              'https://api.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/ventilation.operating.programs.silent/commands/setDefaultRuntime',
            name: 'setDefaultRuntime',
            isExecutable: true,
            params: {
              defaultRuntime: {
                type: 'number',
                required: true,
                constraints: {
                  min: 1,
                  max: 1440,
                  stepping: 1,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/ventilation/features/ventilation.operating.programs.silent',
        gatewayId: gatewaySerial,
        feature: 'ventilation.operating.programs.silent',
        timestamp: '2022-10-09T10:36:17.479Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'ventilation',
      },
      {
        properties: {
          unit: {
            value: 'percent',
            type: 'string',
          },
          value: {
            type: 'number',
            value: 5,
            unit: 'percent',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/ventilation/features/ventilation.heating.recovery',
        gatewayId: gatewaySerial,
        feature: 'ventilation.heating.recovery',
        timestamp: '2022-04-08T16:35:02.444Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'ventilation',
      },
      {
        properties: {
          unit: {
            value: 'partsPerMillion',
            type: 'string',
          },
          value: {
            type: 'number',
            value: 0,
            unit: 'partsPerMillion',
          },
          status: {
            type: 'string',
            value: 'connected',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/ventilation/features/ventilation.sensors.airQuality',
        gatewayId: gatewaySerial,
        feature: 'ventilation.sensors.airQuality',
        timestamp: '2022-04-08T16:35:02.395Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'ventilation',
      },
      {
        properties: {
          unit: {
            value: 'minute',
            type: 'string',
          },
          value: {
            type: 'number',
            value: -409115,
            unit: 'minute',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/ventilation/features/heating.device.time.offset',
        gatewayId: gatewaySerial,
        feature: 'heating.device.time.offset',
        timestamp: '2022-04-08T16:35:02.360Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'ventilation',
      },
      {
        properties: {
          unit: {
            value: 'kilowattHour',
            type: 'string',
          },
          day: {
            type: 'array',
            value: [0, 0, 0, 0, 0, 0, 0, 0],
            unit: 'kilowattHour',
          },
          week: {
            type: 'array',
            value: [0, 0, 0, 0, 0, 0, 0, 0, 0],
            unit: 'kilowattHour',
          },
          month: {
            type: 'array',
            value: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            unit: 'kilowattHour',
          },
          year: {
            type: 'array',
            value: [0, 0],
            unit: 'kilowattHour',
          },
          dayValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          weekValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          monthValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          yearValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/ventilation/features/ventilation.power.consumption.total',
        gatewayId: gatewaySerial,
        feature: 'ventilation.power.consumption.total',
        timestamp: '2022-04-08T16:35:02.455Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'ventilation',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 0,
            unit: 'hour',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/ventilation/features/ventilation.fan.supply.runtime',
        gatewayId: gatewaySerial,
        feature: 'ventilation.fan.supply.runtime',
        timestamp: '2022-04-08T16:35:02.434Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'ventilation',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/ventilation/features/ventilation.bypass.operating.modes.automaticSmoothRegulation',
        gatewayId: gatewaySerial,
        feature: 'ventilation.bypass.operating.modes.automaticSmoothRegulation',
        timestamp: '2022-04-08T16:36:40.083Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'ventilation',
      },
      {
        properties: {
          entries: {
            type: 'array',
            value: [
              {
                priority: 'service',
                timestamp: '2018-01-01T00:00:00.000Z',
                accessLevel: 'customer',
                errorCode: 'P.1',
                audiences: [
                  'IS-SUPPLIER',
                  'IS-DEVELOPMENT',
                  'IS-MANUFACTURING',
                  'IS-AFTERSALES',
                  'IS-AFTERMARKET',
                  'IS-DEVELOPER-VEG',
                  'IS-BIG-DATA',
                  'IS-MANUFACTURING-VEG',
                ],
              },
            ],
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/ventilation/features/device.messages.service.raw',
        gatewayId: gatewaySerial,
        feature: 'device.messages.service.raw',
        timestamp: '2022-04-08T16:35:02.443Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'ventilation',
      },
      {
        properties: {
          status: {
            type: 'string',
            value: 'notConnected',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/ventilation/features/ventilation.sensors.temperature.outside',
        gatewayId: gatewaySerial,
        feature: 'ventilation.sensors.temperature.outside',
        timestamp: '2022-04-08T16:35:02.372Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'ventilation',
      },
      {
        properties: {
          value: {
            type: 'string',
            value: 'silent',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/ventilation/features/ventilation.operating.programs.active',
        gatewayId: gatewaySerial,
        feature: 'ventilation.operating.programs.active',
        timestamp: '2022-04-08T16:35:02.432Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'ventilation',
      },
      {
        properties: {
          unit: {
            value: 'watt',
            type: 'string',
          },
          value: {
            type: 'number',
            value: 257,
            unit: 'watt',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/ventilation/features/ventilation.preHeater.power.consumption.current',
        gatewayId: gatewaySerial,
        feature: 'ventilation.preHeater.power.consumption.current',
        timestamp: '2022-04-08T16:35:02.452Z',
        isEnabled: true,
        isReady: true,
        deviceId: 'ventilation',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          reason: {
            value: 'summerEco',
            type: 'string',
          },
          demand: {
            value: 'heating',
            type: 'string',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.programs.comfortEnergySaving',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.programs.comfortEnergySaving',
        timestamp: '2022-10-07T13:26:52.683Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.modes.standby',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.modes.standby',
        timestamp: '2022-10-11T10:44:02.453Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          mode: {
            type: 'string',
            value: 'WeatherByOutsideSensorControlled',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.regulation',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.regulation',
        timestamp: '2022-10-11T07:45:26.250Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          profile: {
            value: 'none',
            type: 'string',
          },
        },
        commands: {
          activate: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.operating.programs.screedDrying/commands/activate',
            name: 'activate',
            isExecutable: true,
            params: {
              profile: {
                type: 'string',
                required: true,
                constraints: {
                  enum: [
                    'profileManual',
                    'profileA',
                    'profileB',
                    'profileC',
                    'profileD',
                    'profileE',
                    'profileF',
                    'profileG',
                  ],
                },
              },
            },
          },
          deactivate: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.operating.programs.screedDrying/commands/deactivate',
            name: 'deactivate',
            isExecutable: false,
            params: {},
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.programs.screedDrying',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.programs.screedDrying',
        timestamp: '2022-10-11T07:45:25.406Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.programs.fixed',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.programs.fixed',
        timestamp: '2022-10-11T07:45:24.330Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
          entries: {
            value: {
              mon: [
                {
                  mode: 'normal',
                  start: '06:00',
                  end: '22:00',
                  position: 0,
                },
              ],
              tue: [
                {
                  mode: 'normal',
                  start: '06:00',
                  end: '22:00',
                  position: 0,
                },
              ],
              wed: [
                {
                  mode: 'normal',
                  start: '06:00',
                  end: '22:00',
                  position: 0,
                },
              ],
              thu: [
                {
                  mode: 'normal',
                  start: '06:00',
                  end: '22:00',
                  position: 0,
                },
              ],
              fri: [
                {
                  mode: 'normal',
                  start: '06:00',
                  end: '22:00',
                  position: 0,
                },
              ],
              sat: [
                {
                  mode: 'normal',
                  start: '06:00',
                  end: '22:00',
                  position: 0,
                },
              ],
              sun: [
                {
                  mode: 'normal',
                  start: '06:00',
                  end: '22:00',
                  position: 0,
                },
              ],
            },
            type: 'Schedule',
          },
        },
        commands: {
          setSchedule: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.heating.schedule/commands/setSchedule',
            name: 'setSchedule',
            isExecutable: true,
            params: {
              newSchedule: {
                type: 'Schedule',
                required: true,
                constraints: {
                  modes: ['normal', 'comfort'],
                  maxEntries: 4,
                  resolution: 10,
                  defaultMode: 'reduced',
                  overlapAllowed: false,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.heating.schedule',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.heating.schedule',
        timestamp: '2022-10-11T10:44:02.412Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          reason: {
            value: 'unknown',
            type: 'string',
          },
          demand: {
            value: 'heating',
            type: 'string',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.programs.reducedEnergySaving',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.programs.reducedEnergySaving',
        timestamp: '2022-10-07T13:26:52.683Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          reason: {
            value: 'summerEco',
            type: 'string',
          },
          demand: {
            value: 'cooling',
            type: 'string',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.programs.normalCoolingEnergySaving',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.programs.normalCoolingEnergySaving',
        timestamp: '2022-10-07T13:26:52.683Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.modes.dhwAndTestMode',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.modes.dhwAndTestMode',
        timestamp: '2022-10-07T13:26:52.683Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.programs.standby',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.programs.standby',
        timestamp: '2022-10-07T13:26:52.683Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          status: {
            type: 'string',
            value: 'off',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.circulation.pump',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.circulation.pump',
        timestamp: '2022-10-11T07:45:26.237Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          temperature: {
            value: 20,
            unit: 'celsius',
            type: 'number',
          },
          demand: {
            value: 'heating',
            type: 'string',
          },
        },
        commands: {
          setTemperature: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.operating.programs.comfortHeating/commands/setTemperature',
            name: 'setTemperature',
            isExecutable: true,
            params: {
              targetTemperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 3,
                  max: 37,
                  stepping: 1,
                },
              },
            },
          },
          activate: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.operating.programs.comfortHeating/commands/activate',
            name: 'activate',
            isExecutable: false,
            params: {
              temperature: {
                type: 'number',
                required: false,
                constraints: {
                  min: 3,
                  max: 37,
                  stepping: 1,
                },
              },
            },
          },
          deactivate: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.operating.programs.comfortHeating/commands/deactivate',
            name: 'deactivate',
            isExecutable: false,
            params: {},
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.programs.comfortHeating',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.programs.comfortHeating',
        timestamp: '2022-10-11T10:45:13.067Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.modes.testMode',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.modes.testMode',
        timestamp: '2022-10-07T13:26:52.683Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.modes.dhwAndHeating',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.modes.dhwAndHeating',
        timestamp: '2022-10-07T13:26:52.683Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: -8.6,
            unit: 'celsius',
          },
          status: {
            type: 'string',
            value: 'connected',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.sensors.temperature.supply',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.sensors.temperature.supply',
        timestamp: '2022-10-11T09:52:03.126Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          status: {
            type: 'string',
            value: 'off',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.frostprotection',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.frostprotection',
        timestamp: '2022-10-11T10:44:18.544Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 8,
            unit: '',
          },
        },
        commands: {
          setValue: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.heating.roomInfluenceFactor/commands/setValue',
            name: 'setValue',
            isExecutable: true,
            params: {
              value: {
                required: true,
                constraints: {
                  min: 0,
                  max: 64,
                  stepping: 1,
                },
                type: 'number',
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.heating.roomInfluenceFactor',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.heating.roomInfluenceFactor',
        timestamp: '2022-10-11T07:45:26.259Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.modes.heating',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.modes.heating',
        timestamp: '2022-10-11T10:44:02.483Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            value: 'heating',
            type: 'string',
          },
        },
        commands: {
          setMode: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.operating.modes.active/commands/setMode',
            name: 'setMode',
            isExecutable: true,
            params: {
              mode: {
                type: 'string',
                required: true,
                constraints: {
                  enum: ['standby', 'heating', 'dhw', 'dhwAndHeating'],
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.modes.active',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.modes.active',
        timestamp: '2022-10-11T10:44:02.486Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.programs.summerEco',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.programs.summerEco',
        timestamp: '2022-10-11T10:44:18.546Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
          name: {
            value: '',
            type: 'string',
          },
          type: {
            value: 'heatingCircuit',
            type: 'string',
          },
        },
        commands: {
          setName: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0/commands/setName',
            name: 'setName',
            isExecutable: true,
            params: {
              name: {
                type: 'string',
                required: true,
                constraints: {
                  minLength: 1,
                  maxLength: 20,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0',
        timestamp: '2022-10-11T07:45:26.056Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          reason: {
            value: 'summerEco',
            type: 'string',
          },
          demand: {
            value: 'cooling',
            type: 'string',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.programs.reducedCoolingEnergySaving',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.programs.reducedCoolingEnergySaving',
        timestamp: '2022-10-07T13:26:52.683Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          reason: {
            value: 'summerEco',
            type: 'string',
          },
          demand: {
            value: 'cooling',
            type: 'string',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.programs.comfortCoolingEnergySaving',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.programs.comfortCoolingEnergySaving',
        timestamp: '2022-10-07T13:26:52.683Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'string',
            value: 'normalHeating',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.programs.active',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.programs.active',
        timestamp: '2022-10-11T10:44:18.543Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          shift: {
            type: 'number',
            unit: '',
            value: 0,
          },
          slope: {
            type: 'number',
            unit: '',
            value: 0.6,
          },
        },
        commands: {
          setCurve: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.heating.curve/commands/setCurve',
            name: 'setCurve',
            isExecutable: true,
            params: {
              slope: {
                type: 'number',
                required: true,
                constraints: {
                  min: 0.2,
                  max: 3.5,
                  stepping: 0.1,
                },
              },
              shift: {
                type: 'number',
                required: true,
                constraints: {
                  min: -13,
                  max: 40,
                  stepping: 1,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.heating.curve',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.heating.curve',
        timestamp: '2022-10-11T07:45:25.161Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: true,
          },
          threshold: {
            type: 'number',
            value: 25,
            unit: 'celsius',
          },
        },
        commands: {
          activate: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.configuration.summerEco.absolute/commands/activate',
            name: 'activate',
            isExecutable: false,
            params: {
              threshold: {
                type: 'number',
                required: true,
                constraints: {
                  min: 10,
                  max: 35,
                  stepping: 1,
                },
              },
            },
          },
          deactivate: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.configuration.summerEco.absolute/commands/deactivate',
            name: 'deactivate',
            isExecutable: true,
            params: {},
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.configuration.summerEco.absolute',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.configuration.summerEco.absolute',
        timestamp: '2022-10-11T07:45:25.919Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.modes.dhw',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.modes.dhw',
        timestamp: '2022-10-07T13:26:52.683Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.zone.mode',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.zone.mode',
        timestamp: '2022-10-11T07:45:26.227Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {
          activate: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.operating.programs.forcedLastFromSchedule/commands/activate',
            name: 'activate',
            isExecutable: true,
            params: {},
          },
          deactivate: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.operating.programs.forcedLastFromSchedule/commands/deactivate',
            name: 'deactivate',
            isExecutable: false,
            params: {},
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.programs.forcedLastFromSchedule',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.programs.forcedLastFromSchedule',
        timestamp: '2022-10-11T10:44:02.422Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          reason: {
            value: 'summerEco',
            type: 'string',
          },
          demand: {
            value: 'heating',
            type: 'string',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.programs.normalEnergySaving',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.programs.normalEnergySaving',
        timestamp: '2022-10-07T13:26:52.683Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.programs.frostprotection',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.programs.frostprotection',
        timestamp: '2022-10-11T10:44:18.530Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
          temperature: {
            value: 20,
            unit: 'celsius',
            type: 'number',
          },
          demand: {
            value: 'heating',
            type: 'string',
          },
        },
        commands: {
          setTemperature: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.operating.programs.normalHeating/commands/setTemperature',
            name: 'setTemperature',
            isExecutable: true,
            params: {
              targetTemperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 3,
                  max: 37,
                  stepping: 1,
                },
              },
            },
          },
          activate: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.operating.programs.normalHeating/commands/activate',
            name: 'activate',
            isExecutable: false,
            params: {
              temperature: {
                type: 'number',
                required: false,
                constraints: {
                  min: 3,
                  max: 37,
                  stepping: 1,
                },
              },
            },
          },
          deactivate: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.operating.programs.normalHeating/commands/deactivate',
            name: 'deactivate',
            isExecutable: false,
            params: {},
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.programs.normalHeating',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.programs.normalHeating',
        timestamp: '2022-10-11T10:46:16.657Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          temperature: {
            value: 20,
            unit: 'celsius',
            type: 'number',
          },
          demand: {
            value: 'heating',
            type: 'string',
          },
        },
        commands: {
          setTemperature: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.operating.programs.reducedHeating/commands/setTemperature',
            name: 'setTemperature',
            isExecutable: true,
            params: {
              targetTemperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 3,
                  max: 37,
                  stepping: 1,
                },
              },
            },
          },
          activate: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.operating.programs.reducedHeating/commands/activate',
            name: 'activate',
            isExecutable: false,
            params: {
              temperature: {
                type: 'number',
                required: false,
                constraints: {
                  min: 3,
                  max: 37,
                  stepping: 1,
                },
              },
            },
          },
          deactivate: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.operating.programs.reducedHeating/commands/deactivate',
            name: 'deactivate',
            isExecutable: false,
            params: {},
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.operating.programs.reducedHeating',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.0.operating.programs.reducedHeating',
        timestamp: '2022-10-11T10:45:13.070Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        apiVersion: 1,
        isEnabled: true,
        isReady: true,
        timestamp: '2022-10-07T13:26:52.683Z',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.0.name',
        feature: 'heating.circuits.0.name',
        deviceId: '0',
        gatewayId: gatewaySerial,
        commands: {
          setName: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.0.name/commands/setName',
            name: 'setName',
            isExecutable: true,
            params: {
              name: {
                type: 'string',
                required: true,
                constraints: {
                  minLength: 1,
                  maxLength: 20,
                },
              },
            },
          },
        },
        properties: {
          name: {
            type: 'string',
            value: '',
          },
        },
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          temperature: {
            value: 23,
            unit: 'celsius',
            type: 'number',
          },
          demand: {
            value: 'cooling',
            type: 'string',
          },
        },
        commands: {
          setTemperature: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1.operating.programs.comfortCooling/commands/setTemperature',
            name: 'setTemperature',
            isExecutable: true,
            params: {
              targetTemperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 12,
                  max: 30,
                  stepping: 1,
                },
              },
            },
          },
          activate: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1.operating.programs.comfortCooling/commands/activate',
            name: 'activate',
            isExecutable: false,
            params: {
              temperature: {
                type: 'number',
                required: false,
                constraints: {
                  min: 12,
                  max: 30,
                  stepping: 1,
                },
              },
            },
          },
          deactivate: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1.operating.programs.comfortCooling/commands/deactivate',
            name: 'deactivate',
            isExecutable: false,
            params: {},
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.programs.comfortCooling',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.programs.comfortCooling',
        timestamp: '2022-10-09T08:06:57.840Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 0,
            unit: 'kilowattHour/year',
          },
        },
        commands: {
          setValue: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.configuration.houseHeatingLoad/commands/setValue',
            name: 'setValue',
            isExecutable: true,
            params: {
              value: {
                required: true,
                constraints: {
                  min: 0,
                  max: 65531,
                  stepping: 1,
                },
                type: 'number',
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.configuration.houseHeatingLoad',
        gatewayId: gatewaySerial,
        feature: 'heating.configuration.houseHeatingLoad',
        timestamp: '2022-10-09T08:07:06.204Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          currentDay: {
            type: 'number',
            value: 0,
            unit: 'kilowattHour',
          },
          lastSevenDays: {
            type: 'number',
            value: 0,
            unit: 'kilowattHour',
          },
          currentMonth: {
            type: 'number',
            value: 0,
            unit: 'kilowattHour',
          },
          lastMonth: {
            type: 'number',
            value: 0,
            unit: 'kilowattHour',
          },
          currentYear: {
            type: 'number',
            value: 0,
            unit: 'kilowattHour',
          },
          lastYear: {
            type: 'number',
            value: 0,
            unit: 'kilowattHour',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.heat.production.summary.cooling',
        gatewayId: gatewaySerial,
        feature: 'heating.heat.production.summary.cooling',
        timestamp: '2022-10-09T08:07:05.054Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.zone.mode',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.zone.mode',
        timestamp: '2022-10-09T08:07:06.234Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          status: {
            type: 'string',
            value: 'connected',
          },
          value: {
            type: 'string',
            value: 'off',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.sensors.humidity.dewpoint',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.sensors.humidity.dewpoint',
        timestamp: '2022-10-09T08:07:03.821Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          mode: {
            type: 'string',
            value: 'WeatherByOutsideSensorControlled',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.3.regulation',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.3.regulation',
        timestamp: '2022-10-09T08:07:06.271Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          currentValue: {
            type: 'string',
            value: 'off',
          },
          targetValue: {
            type: 'string',
            value: 'off',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.secondaryCircuit.operation.state',
        gatewayId: gatewaySerial,
        feature: 'heating.secondaryCircuit.operation.state',
        timestamp: '2022-10-09T08:07:03.813Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 54.9,
            unit: 'celsius',
          },
          status: {
            type: 'string',
            value: 'connected',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.sensors.temperature.hotWaterStorage',
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.sensors.temperature.hotWaterStorage',
        timestamp: '2022-10-10T10:11:38.861Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 8,
            unit: '',
          },
        },
        commands: {
          setValue: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1.heating.roomInfluenceFactor/commands/setValue',
            name: 'setValue',
            isExecutable: true,
            params: {
              value: {
                required: true,
                constraints: {
                  min: 0,
                  max: 64,
                  stepping: 1,
                },
                type: 'number',
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.heating.roomInfluenceFactor',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.heating.roomInfluenceFactor',
        timestamp: '2022-10-09T08:07:06.279Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          temperature: {
            value: 23,
            unit: 'celsius',
            type: 'number',
          },
          demand: {
            value: 'cooling',
            type: 'string',
          },
        },
        commands: {
          setTemperature: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1.operating.programs.normalCooling/commands/setTemperature',
            name: 'setTemperature',
            isExecutable: true,
            params: {
              targetTemperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 12,
                  max: 30,
                  stepping: 1,
                },
              },
            },
          },
          activate: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1.operating.programs.normalCooling/commands/activate',
            name: 'activate',
            isExecutable: false,
            params: {
              temperature: {
                type: 'number',
                required: false,
                constraints: {
                  min: 12,
                  max: 30,
                  stepping: 1,
                },
              },
            },
          },
          deactivate: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1.operating.programs.normalCooling/commands/deactivate',
            name: 'deactivate',
            isExecutable: false,
            params: {},
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.programs.normalCooling',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.programs.normalCooling',
        timestamp: '2022-10-09T08:06:57.841Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          useApproved: {
            value: true,
            type: 'boolean',
          },
        },
        commands: {
          grant: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.configuration.heatingRod.dhw/commands/grant',
            name: 'grant',
            isExecutable: false,
            params: {},
          },
          revoke: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.configuration.heatingRod.dhw/commands/revoke',
            name: 'revoke',
            isExecutable: true,
            params: {},
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.configuration.heatingRod.dhw',
        gatewayId: gatewaySerial,
        feature: 'heating.configuration.heatingRod.dhw',
        timestamp: '2022-10-09T08:06:57.841Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          reason: {
            value: 'unknown',
            type: 'string',
          },
          demand: {
            value: 'heating',
            type: 'string',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.2.operating.programs.reducedEnergySaving',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.2.operating.programs.reducedEnergySaving',
        timestamp: '2022-10-09T08:06:57.841Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {
          activate: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.outdoor.defrosting/commands/activate',
            name: 'activate',
            isExecutable: true,
            params: {},
          },
          deactivate: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.outdoor.defrosting/commands/deactivate',
            name: 'deactivate',
            isExecutable: false,
            params: {},
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.outdoor.defrosting',
        gatewayId: gatewaySerial,
        feature: 'heating.outdoor.defrosting',
        timestamp: '2022-10-09T08:06:57.841Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          entries: {
            type: 'array',
            value: [
              {
                priority: 'criticalError',
                timestamp: '2022-10-03T09:19:04.000Z',
                accessLevel: 'customer',
                errorCode: 'F.1034',
                audiences: [
                  'IS-SUPPLIER',
                  'IS-DEVELOPMENT',
                  'IS-MANUFACTURING',
                  'IS-AFTERSALES',
                  'IS-AFTERMARKET',
                  'IS-DEVELOPER-VEG',
                  'IS-BIG-DATA',
                  'IS-MANUFACTURING-VEG',
                ],
              },
              {
                priority: 'criticalError',
                timestamp: '2022-10-03T09:18:06.000Z',
                accessLevel: 'customer',
                errorCode: 'F.875',
                audiences: [
                  'IS-SUPPLIER',
                  'IS-DEVELOPMENT',
                  'IS-MANUFACTURING',
                  'IS-AFTERSALES',
                  'IS-AFTERMARKET',
                  'IS-DEVELOPER-VEG',
                  'IS-BIG-DATA',
                  'IS-MANUFACTURING-VEG',
                ],
              },
              {
                priority: 'criticalError',
                timestamp: '2022-10-03T09:17:46.000Z',
                accessLevel: 'customer',
                errorCode: 'F.520',
                audiences: [
                  'IS-SUPPLIER',
                  'IS-DEVELOPMENT',
                  'IS-MANUFACTURING',
                  'IS-AFTERSALES',
                  'IS-AFTERMARKET',
                  'IS-DEVELOPER-VEG',
                  'IS-BIG-DATA',
                  'IS-MANUFACTURING-VEG',
                ],
              },
            ],
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/device.messages.errors.raw',
        gatewayId: gatewaySerial,
        feature: 'device.messages.errors.raw',
        timestamp: '2022-10-09T08:07:06.297Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 8,
            unit: '',
          },
        },
        commands: {
          setValue: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.3.heating.roomInfluenceFactor/commands/setValue',
            name: 'setValue',
            isExecutable: true,
            params: {
              value: {
                required: true,
                constraints: {
                  min: 0,
                  max: 64,
                  stepping: 1,
                },
                type: 'number',
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.3.heating.roomInfluenceFactor',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.3.heating.roomInfluenceFactor',
        timestamp: '2022-10-09T08:07:06.283Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          entries: {
            type: 'ErrorListChanges',
            constraints: {},
            value: {
              new: [],
              current: [],
              gone: [],
            },
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/device.messages.service.active',
        gatewayId: gatewaySerial,
        feature: 'device.messages.service.active',
        timestamp: '2022-10-07T18:18:06.318Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          currentDay: {
            type: 'number',
            value: 0,
            unit: 'kilowattHour',
          },
          lastSevenDays: {
            type: 'number',
            value: 0,
            unit: 'kilowattHour',
          },
          currentMonth: {
            type: 'number',
            value: 0,
            unit: 'kilowattHour',
          },
          lastMonth: {
            type: 'number',
            value: 0,
            unit: 'kilowattHour',
          },
          currentYear: {
            type: 'number',
            value: 0,
            unit: 'kilowattHour',
          },
          lastYear: {
            type: 'number',
            value: 0,
            unit: 'kilowattHour',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.power.consumption.summary.cooling',
        gatewayId: gatewaySerial,
        feature: 'heating.power.consumption.summary.cooling',
        timestamp: '2022-10-09T08:07:05.056Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 39.1,
            unit: 'celsius',
          },
          status: {
            type: 'string',
            value: 'connected',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.economizers.0.sensors.temperature.liquid',
        gatewayId: gatewaySerial,
        feature: 'heating.economizers.0.sensors.temperature.liquid',
        timestamp: '2022-10-10T10:11:46.923Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.modes.auto',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.modes.auto',
        timestamp: '2022-10-09T08:06:57.841Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.evaporators.0.heater.base',
        gatewayId: gatewaySerial,
        feature: 'heating.evaporators.0.heater.base',
        timestamp: '2022-10-09T08:07:05.174Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          target: {
            type: 'number',
            value: 45,
            unit: 'percent',
          },
          current: {
            type: 'number',
            value: 45,
            unit: 'percent',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.secondaryCircuit.valves.fourWay',
        gatewayId: gatewaySerial,
        feature: 'heating.secondaryCircuit.valves.fourWay',
        timestamp: '2022-10-09T08:07:05.103Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 95,
            unit: 'percent',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.boiler.pumps.internal.target',
        gatewayId: gatewaySerial,
        feature: 'heating.boiler.pumps.internal.target',
        timestamp: '2022-10-09T08:07:05.989Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          status: {
            type: 'string',
            value: 'connected',
          },
          value: {
            type: 'number',
            value: 15.6,
            unit: 'celsius',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.compressors.0.sensors.temperature.inlet',
        gatewayId: gatewaySerial,
        feature: 'heating.compressors.0.sensors.temperature.inlet',
        timestamp: '2022-10-10T10:11:33.774Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.modes.dhwAndHeating',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.modes.dhwAndHeating',
        timestamp: '2022-10-09T08:06:57.841Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 8.5,
            unit: 'bar',
          },
          status: {
            type: 'string',
            value: 'connected',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.compressors.0.sensors.pressure.outlet',
        gatewayId: gatewaySerial,
        feature: 'heating.compressors.0.sensors.pressure.outlet',
        timestamp: '2022-10-10T10:11:46.927Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          reason: {
            value: 'summerEco',
            type: 'string',
          },
          demand: {
            value: 'heating',
            type: 'string',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.programs.normalEnergySaving',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.programs.normalEnergySaving',
        timestamp: '2022-10-09T08:06:57.841Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          status: {
            type: 'string',
            value: 'connected',
          },
          value: {
            type: 'number',
            value: 0,
            unit: 'watt',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.compressors.0.heat.production.current',
        gatewayId: gatewaySerial,
        feature: 'heating.compressors.0.heat.production.current',
        timestamp: '2022-10-09T08:07:05.087Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          activationThreshold: {
            unit: 'celsius',
            type: 'number',
            value: 2,
          },
          deactivationThreshold: {
            type: 'number',
            value: 1,
            unit: 'celsius',
          },
        },
        commands: {
          setThresholds: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1.cooling.hysteresis/commands/setThresholds',
            name: 'setThresholds',
            isExecutable: true,
            params: {
              activationThreshold: {
                type: 'number',
                required: true,
                constraints: {
                  min: 0.5,
                  max: 10,
                  stepping: 0.1,
                },
              },
              deactivationThreshold: {
                type: 'number',
                required: true,
                constraints: {
                  min: 0.5,
                  max: 10,
                  stepping: 0.1,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.cooling.hysteresis',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.cooling.hysteresis',
        timestamp: '2022-10-09T08:06:57.841Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.modes.heating',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.modes.heating',
        timestamp: '2022-10-09T08:06:57.841Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
          entries: {
            value: {
              mon: [],
              tue: [],
              wed: [],
              thu: [],
              fri: [],
              sat: [],
              sun: [],
            },
            type: 'Schedule',
          },
        },
        commands: {
          setSchedule: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1.heating.schedule/commands/setSchedule',
            name: 'setSchedule',
            isExecutable: true,
            params: {
              newSchedule: {
                type: 'Schedule',
                required: true,
                constraints: {
                  modes: ['normal', 'comfort'],
                  maxEntries: 4,
                  resolution: 10,
                  defaultMode: 'reduced',
                  overlapAllowed: false,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.heating.schedule',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.heating.schedule',
        timestamp: '2022-10-09T08:06:57.841Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          status: {
            type: 'string',
            value: 'connected',
          },
          value: {
            type: 'number',
            value: 0,
            unit: 'percent',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.sensors.valve.1.expansion',
        gatewayId: gatewaySerial,
        feature: 'heating.sensors.valve.1.expansion',
        timestamp: '2022-10-09T08:07:03.816Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          reason: {
            value: 'summerEco',
            type: 'string',
          },
          demand: {
            value: 'cooling',
            type: 'string',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.programs.comfortCoolingEnergySaving',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.programs.comfortCoolingEnergySaving',
        timestamp: '2022-10-09T08:06:57.841Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          requestedState: {
            value: 'unknown',
            type: 'string',
          },
          actualState: {
            value: 'normalOperation',
            type: 'string',
          },
        },
        commands: {
          requestSmartGridState: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.device.smartGrid/commands/requestSmartGridState',
            name: 'requestSmartGridState',
            isExecutable: true,
            params: {
              id: {
                type: 'string',
                required: true,
                constraints: {
                  enum: ['off', 'normalOperation', 'recommendedOperation', 'forcedOperation'],
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.device.smartGrid',
        gatewayId: gatewaySerial,
        feature: 'heating.device.smartGrid',
        timestamp: '2022-10-09T08:06:57.841Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          useApproved: {
            value: false,
            type: 'boolean',
          },
          activated: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {
          grant: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.device.comfortEnsuring/commands/grant',
            name: 'grant',
            isExecutable: false,
            params: {},
          },
          revoke: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.device.comfortEnsuring/commands/revoke',
            name: 'revoke',
            isExecutable: false,
            params: {},
          },
          acknowledgeActivation: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.device.comfortEnsuring/commands/acknowledgeActivation',
            name: 'acknowledgeActivation',
            isExecutable: false,
            params: {},
          },
          activateManually: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.device.comfortEnsuring/commands/activateManually',
            name: 'activateManually',
            isExecutable: true,
            params: {},
          },
          deactivateManually: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.device.comfortEnsuring/commands/deactivateManually',
            name: 'deactivateManually',
            isExecutable: false,
            params: {},
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.device.comfortEnsuring',
        gatewayId: gatewaySerial,
        feature: 'heating.device.comfortEnsuring',
        timestamp: '2022-10-09T08:06:57.841Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
        },
        commands: {
          activate: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/device.zigbee.active/commands/activate',
            name: 'activate',
            isExecutable: false,
            params: {},
          },
          deactivate: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/device.zigbee.active/commands/deactivate',
            name: 'deactivate',
            isExecutable: true,
            params: {},
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/device.zigbee.active',
        gatewayId: gatewaySerial,
        feature: 'device.zigbee.active',
        timestamp: '2022-10-09T08:06:57.841Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          starts: {
            type: 'number',
            value: 0,
            unit: '',
          },
          hours: {
            type: 'number',
            value: 0,
            unit: 'hour',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.heatingRod.statistics',
        gatewayId: gatewaySerial,
        feature: 'heating.heatingRod.statistics',
        timestamp: '2022-10-09T08:07:05.035Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          enabled: {
            type: 'array',
            value: ['0'],
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.compressors',
        gatewayId: gatewaySerial,
        feature: 'heating.compressors',
        timestamp: '2022-10-09T08:07:05.036Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          status: {
            type: 'string',
            value: 'connected',
          },
          value: {
            type: 'number',
            value: 5,
            unit: 'celsius',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.sensors.temperature.allengra',
        gatewayId: gatewaySerial,
        feature: 'heating.sensors.temperature.allengra',
        timestamp: '2022-10-09T08:07:06.197Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/device.lock.malfunction',
        gatewayId: gatewaySerial,
        feature: 'device.lock.malfunction',
        timestamp: '2022-10-09T08:07:06.335Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {
          activate: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1.operating.programs.forcedLastFromSchedule/commands/activate',
            name: 'activate',
            isExecutable: false,
            params: {},
          },
          deactivate: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1.operating.programs.forcedLastFromSchedule/commands/deactivate',
            name: 'deactivate',
            isExecutable: false,
            params: {},
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.programs.forcedLastFromSchedule',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.programs.forcedLastFromSchedule',
        timestamp: '2022-10-09T08:06:57.841Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          status: {
            type: 'string',
            value: 'connected',
          },
          value: {
            type: 'number',
            value: 0,
            unit: 'watt',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.heatingRod.heat.production.current',
        gatewayId: gatewaySerial,
        feature: 'heating.heatingRod.heat.production.current',
        timestamp: '2022-10-09T08:07:05.099Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 17.8,
            unit: 'celsius',
          },
          status: {
            type: 'string',
            value: 'connected',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.primaryCircuit.sensors.temperature.supply',
        gatewayId: gatewaySerial,
        feature: 'heating.primaryCircuit.sensors.temperature.supply',
        timestamp: '2022-10-10T10:11:43.894Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 0,
            unit: 'watt',
          },
          status: {
            type: 'string',
            value: 'connected',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.compressors.0.power.consumption.current',
        gatewayId: gatewaySerial,
        feature: 'heating.compressors.0.power.consumption.current',
        timestamp: '2022-10-09T08:07:05.089Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          entries: {
            type: 'ErrorListChanges',
            constraints: {},
            value: {
              new: [],
              current: [
                {
                  priority: 'status',
                  timestamp: '2022-10-05T15:06:35.650Z',
                  accessLevel: 'customer',
                  errorCode: 'S.165',
                  audiences: [
                    'IS-SUPPLIER',
                    'IS-DEVELOPMENT',
                    'IS-MANUFACTURING',
                    'IS-AFTERSALES',
                    'IS-AFTERMARKET',
                    'IS-DEVELOPER-VEG',
                    'IS-BIG-DATA',
                    'IS-MANUFACTURING-VEG',
                  ],
                },
                {
                  priority: 'status',
                  timestamp: '2022-10-09T22:47:18.772Z',
                  accessLevel: 'customer',
                  errorCode: 'S.217',
                  audiences: [
                    'IS-SUPPLIER',
                    'IS-DEVELOPMENT',
                    'IS-MANUFACTURING',
                    'IS-AFTERSALES',
                    'IS-AFTERMARKET',
                    'IS-DEVELOPER-VEG',
                    'IS-BIG-DATA',
                    'IS-MANUFACTURING-VEG',
                  ],
                },
                {
                  priority: 'status',
                  timestamp: '2022-10-08T01:56:54.925Z',
                  accessLevel: 'customer',
                  errorCode: 'S.218',
                  audiences: [
                    'IS-SUPPLIER',
                    'IS-DEVELOPMENT',
                    'IS-MANUFACTURING',
                    'IS-AFTERSALES',
                    'IS-AFTERMARKET',
                    'IS-DEVELOPER-VEG',
                    'IS-BIG-DATA',
                    'IS-MANUFACTURING-VEG',
                  ],
                },
                {
                  priority: 'status',
                  timestamp: '2022-10-05T15:06:35.650Z',
                  accessLevel: 'customer',
                  errorCode: 'S.219',
                  audiences: [
                    'IS-SUPPLIER',
                    'IS-DEVELOPMENT',
                    'IS-MANUFACTURING',
                    'IS-AFTERSALES',
                    'IS-AFTERMARKET',
                    'IS-DEVELOPER-VEG',
                    'IS-BIG-DATA',
                    'IS-MANUFACTURING-VEG',
                  ],
                },
                {
                  priority: 'status',
                  timestamp: '2022-10-09T22:28:38.041Z',
                  accessLevel: 'customer',
                  errorCode: 'S.120',
                  audiences: [
                    'IS-SUPPLIER',
                    'IS-DEVELOPMENT',
                    'IS-MANUFACTURING',
                    'IS-AFTERSALES',
                    'IS-AFTERMARKET',
                    'IS-DEVELOPER-VEG',
                    'IS-BIG-DATA',
                    'IS-MANUFACTURING-VEG',
                  ],
                },
                {
                  priority: 'status',
                  timestamp: '2022-10-05T15:06:35.650Z',
                  accessLevel: 'customer',
                  errorCode: 'S.123',
                  audiences: [
                    'IS-SUPPLIER',
                    'IS-DEVELOPMENT',
                    'IS-MANUFACTURING',
                    'IS-AFTERSALES',
                    'IS-AFTERMARKET',
                    'IS-DEVELOPER-VEG',
                    'IS-BIG-DATA',
                    'IS-MANUFACTURING-VEG',
                  ],
                },
                {
                  priority: 'status',
                  timestamp: '2022-10-05T15:06:35.650Z',
                  accessLevel: 'customer',
                  errorCode: 'S.117',
                  audiences: [
                    'IS-SUPPLIER',
                    'IS-DEVELOPMENT',
                    'IS-MANUFACTURING',
                    'IS-AFTERSALES',
                    'IS-AFTERMARKET',
                    'IS-DEVELOPER-VEG',
                    'IS-BIG-DATA',
                    'IS-MANUFACTURING-VEG',
                  ],
                },
                {
                  priority: 'status',
                  timestamp: '2022-10-05T15:06:35.650Z',
                  accessLevel: 'customer',
                  errorCode: 'S.165',
                  audiences: [
                    'IS-SUPPLIER',
                    'IS-DEVELOPMENT',
                    'IS-MANUFACTURING',
                    'IS-AFTERSALES',
                    'IS-AFTERMARKET',
                    'IS-DEVELOPER-VEG',
                    'IS-BIG-DATA',
                    'IS-MANUFACTURING-VEG',
                  ],
                },
              ],
              gone: [],
            },
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/device.messages.status.active',
        gatewayId: gatewaySerial,
        feature: 'device.messages.status.active',
        timestamp: '2022-10-10T10:10:27.022Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          status: {
            type: 'string',
            value: 'connected',
          },
          value: {
            type: 'number',
            value: 1000,
            unit: 'liter',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.sensors.volumetricFlow.allengra',
        gatewayId: gatewaySerial,
        feature: 'heating.sensors.volumetricFlow.allengra',
        timestamp: '2022-10-09T08:07:06.195Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'array',
            value: [
              {
                busAddress: 1,
                busType: 'CanInternal',
                deviceObjectProperty: 'HPMUMaster',
                deviceFunction: 'VitocalTwoHundredFiftyTwoA',
                softwareVersion: '0020.0409.2233.0164',
                hardwareVersion: '65535.65535.65535.65535',
                etn: '9999999�99999���',
              },
              {
                busAddress: 66,
                busType: 'CanInternal',
                deviceObjectProperty: 'ADIO',
                deviceFunction: 'Nothing',
                softwareVersion: '0083.0300.2139.0020',
                hardwareVersion: '65535.65535.65535.65535',
                etn: '9999999�99999���',
              },
              {
                busAddress: 67,
                busType: 'CanInternal',
                deviceObjectProperty: 'EHCU',
                deviceFunction: 'No',
                softwareVersion: '0040.0409.2233.0103',
                hardwareVersion: '65535.65535.65535.65535',
                etn: '9999999�99999���',
              },
              {
                busAddress: 54,
                busType: 'CanInternal',
                deviceObjectProperty: 'VCMU',
                deviceFunction: 'No',
                softwareVersion: '0021.0409.2233.0121',
                hardwareVersion: '65535.65535.65535.65535',
                etn: '9999999�99999���',
              },
              {
                busAddress: 59,
                busType: 'CanInternal',
                deviceObjectProperty: 'HMI',
                deviceFunction: 'No',
                softwareVersion: '0087.0300.2225.0003',
                hardwareVersion: '0087.0100.0100.0000',
                etn: 'HMI-MINIMAL--001',
              },
              {
                busAddress: 68,
                busType: 'CanInternal',
                deviceObjectProperty: 'BackendGateway',
                deviceFunction: 'Nothing',
                softwareVersion: '0063.0501.2215.0038',
                hardwareVersion: '0063.0500.0501.0000',
                etn: '7948214001418225',
              },
              {
                busAddress: 58,
                busType: 'CanInternal',
                deviceObjectProperty: 'BackendGateway',
                deviceFunction: 'Nothing',
                softwareVersion: '0010.0408.2231.0002',
                hardwareVersion: '0010.0001.0000.0000',
                etn: '' + gatewaySerial + '',
              },
            ],
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/device.busTopology',
        gatewayId: gatewaySerial,
        feature: 'device.busTopology',
        timestamp: '2022-10-09T08:07:06.336Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          useApproved: {
            value: true,
            type: 'boolean',
          },
        },
        commands: {
          grant: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.configuration.heatingRod.general/commands/grant',
            name: 'grant',
            isExecutable: false,
            params: {},
          },
          revoke: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.configuration.heatingRod.general/commands/revoke',
            name: 'revoke',
            isExecutable: false,
            params: {},
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.configuration.heatingRod.general',
        gatewayId: gatewaySerial,
        feature: 'heating.configuration.heatingRod.general',
        timestamp: '2022-10-09T08:06:57.841Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          mode: {
            type: 'string',
            value: 'WeatherByOutsideSensorControlled',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.regulation',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.regulation',
        timestamp: '2022-10-09T08:07:06.269Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          currentDay: {
            type: 'number',
            value: 0,
            unit: 'kilowattHour',
          },
          lastSevenDays: {
            type: 'number',
            value: 0,
            unit: 'kilowattHour',
          },
          currentMonth: {
            type: 'number',
            value: 0,
            unit: 'kilowattHour',
          },
          lastMonth: {
            type: 'number',
            value: 0,
            unit: 'kilowattHour',
          },
          currentYear: {
            type: 'number',
            value: 0,
            unit: 'kilowattHour',
          },
          lastYear: {
            type: 'number',
            value: 0,
            unit: 'kilowattHour',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.heat.production.summary.dhw',
        gatewayId: gatewaySerial,
        feature: 'heating.heat.production.summary.dhw',
        timestamp: '2022-10-09T08:07:06.290Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: true,
          },
          threshold: {
            type: 'number',
            value: 25,
            unit: 'celsius',
          },
        },
        commands: {
          activate: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1.configuration.summerEco.absolute/commands/activate',
            name: 'activate',
            isExecutable: false,
            params: {
              threshold: {
                type: 'number',
                required: true,
                constraints: {
                  min: 10,
                  max: 35,
                  stepping: 1,
                },
              },
            },
          },
          deactivate: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1.configuration.summerEco.absolute/commands/deactivate',
            name: 'deactivate',
            isExecutable: true,
            params: {},
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.configuration.summerEco.absolute',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.configuration.summerEco.absolute',
        timestamp: '2022-10-09T08:06:57.841Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 39.1,
            unit: 'celsius',
          },
          status: {
            type: 'string',
            value: 'connected',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.condensors.0.sensors.temperature.liquid',
        gatewayId: gatewaySerial,
        feature: 'heating.condensors.0.sensors.temperature.liquid',
        timestamp: '2022-10-10T10:11:19.563Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          shift: {
            type: 'number',
            unit: '',
            value: 0,
          },
          slope: {
            type: 'number',
            unit: '',
            value: 0.6,
          },
        },
        commands: {
          setCurve: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1.heating.curve/commands/setCurve',
            name: 'setCurve',
            isExecutable: true,
            params: {
              slope: {
                type: 'number',
                required: true,
                constraints: {
                  min: 0.2,
                  max: 3.5,
                  stepping: 0.1,
                },
              },
              shift: {
                type: 'number',
                required: true,
                constraints: {
                  min: -13,
                  max: 40,
                  stepping: 1,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.heating.curve',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.heating.curve',
        timestamp: '2022-10-09T08:06:57.841Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 0,
            unit: 'liter',
          },
        },
        commands: {
          setValue: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.configuration.bufferCylinderSize/commands/setValue',
            name: 'setValue',
            isExecutable: true,
            params: {
              value: {
                required: true,
                constraints: {
                  min: 0,
                  max: 6553.5,
                  stepping: 0.1,
                },
                type: 'number',
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.configuration.bufferCylinderSize',
        gatewayId: gatewaySerial,
        feature: 'heating.configuration.bufferCylinderSize',
        timestamp: '2022-10-09T08:07:06.200Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.modes.cooling',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.modes.cooling',
        timestamp: '2022-10-09T08:06:57.841Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          overall: {
            type: 'boolean',
            value: false,
          },
          level1: {
            type: 'boolean',
            value: false,
          },
          level2: {
            type: 'boolean',
            value: false,
          },
          level3: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.heatingRod.status',
        gatewayId: gatewaySerial,
        feature: 'heating.heatingRod.status',
        timestamp: '2022-10-09T08:07:05.031Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          entries: {
            type: 'array',
            value: [],
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/device.messages.warnings.raw',
        gatewayId: gatewaySerial,
        feature: 'device.messages.warnings.raw',
        timestamp: '2022-10-09T08:07:06.324Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          mode: {
            value: 'WeatherByOutsideSensorControlled',
            type: 'string',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.configuration.regulation',
        gatewayId: gatewaySerial,
        feature: 'heating.configuration.regulation',
        timestamp: '2022-10-09T08:06:57.841Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          entries: {
            type: 'ErrorListChanges',
            constraints: {},
            value: {
              new: [],
              current: [
                {
                  priority: 'info',
                  timestamp: '2022-10-03T07:20:09.879Z',
                  accessLevel: 'customer',
                  errorCode: 'I.114',
                  audiences: [
                    'IS-SUPPLIER',
                    'IS-DEVELOPMENT',
                    'IS-MANUFACTURING',
                    'IS-AFTERSALES',
                    'IS-AFTERMARKET',
                    'IS-DEVELOPER-VEG',
                    'IS-BIG-DATA',
                    'IS-MANUFACTURING-VEG',
                  ],
                },
              ],
              gone: [],
            },
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/device.messages.info.active',
        gatewayId: gatewaySerial,
        feature: 'device.messages.info.active',
        timestamp: '2022-10-07T18:18:06.311Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            value: 'individual',
            type: 'string',
          },
        },
        commands: {
          setMode: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.dhw.schedule.mode/commands/setMode',
            name: 'setMode',
            isExecutable: false,
            params: {
              mode: {
                type: 'string',
                required: true,
                constraints: {
                  enum: ['individual'],
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.schedule.mode',
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.schedule.mode',
        timestamp: '2022-10-09T08:07:05.192Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          profile: {
            value: 'none',
            type: 'string',
          },
        },
        commands: {
          activate: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1.operating.programs.screedDrying/commands/activate',
            name: 'activate',
            isExecutable: true,
            params: {
              profile: {
                type: 'string',
                required: true,
                constraints: {
                  enum: [
                    'profileManual',
                    'profileA',
                    'profileB',
                    'profileC',
                    'profileD',
                    'profileE',
                    'profileF',
                    'profileG',
                  ],
                },
              },
            },
          },
          deactivate: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1.operating.programs.screedDrying/commands/deactivate',
            name: 'deactivate',
            isExecutable: false,
            params: {},
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.programs.screedDrying',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.programs.screedDrying',
        timestamp: '2022-10-09T08:06:57.841Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.modes.testMode',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.modes.testMode',
        timestamp: '2022-10-09T08:06:57.841Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          changeableByEndCustomer: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {
          activate: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.noise.reduction/commands/activate',
            name: 'activate',
            isExecutable: true,
            params: {},
          },
          deactivate: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.noise.reduction/commands/deactivate',
            name: 'deactivate',
            isExecutable: false,
            params: {},
          },
          setChangeableByEndCustomer: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.noise.reduction/commands/setChangeableByEndCustomer',
            name: 'setChangeableByEndCustomer',
            isExecutable: true,
            params: {
              changeable: {
                type: 'boolean',
                constraints: {},
                required: true,
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.noise.reduction',
        gatewayId: gatewaySerial,
        feature: 'heating.noise.reduction',
        timestamp: '2022-10-09T08:06:57.841Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          currentDay: {
            type: 'number',
            value: 0,
            unit: 'kilowattHour',
          },
          lastSevenDays: {
            type: 'number',
            value: 0,
            unit: 'kilowattHour',
          },
          currentMonth: {
            type: 'number',
            value: 0,
            unit: 'kilowattHour',
          },
          lastMonth: {
            type: 'number',
            value: 0,
            unit: 'kilowattHour',
          },
          currentYear: {
            type: 'number',
            value: 8.2,
            unit: 'kilowattHour',
          },
          lastYear: {
            type: 'number',
            value: 0,
            unit: 'kilowattHour',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.heatingRod.power.consumption.summary.heating',
        gatewayId: gatewaySerial,
        feature: 'heating.heatingRod.power.consumption.summary.heating',
        timestamp: '2022-10-09T08:07:05.106Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          currentDay: {
            type: 'number',
            value: 0,
            unit: 'kilowattHour',
          },
          lastSevenDays: {
            type: 'number',
            value: 0,
            unit: 'kilowattHour',
          },
          currentMonth: {
            type: 'number',
            value: 0,
            unit: 'kilowattHour',
          },
          lastMonth: {
            type: 'number',
            value: 0,
            unit: 'kilowattHour',
          },
          currentYear: {
            type: 'number',
            value: 0,
            unit: 'kilowattHour',
          },
          lastYear: {
            type: 'number',
            value: 0,
            unit: 'kilowattHour',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.heatingRod.power.consumption.summary.dhw',
        gatewayId: gatewaySerial,
        feature: 'heating.heatingRod.power.consumption.summary.dhw',
        timestamp: '2022-10-09T08:07:05.095Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            value: 'auto',
            type: 'string',
          },
        },
        commands: {
          setMode: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1.operating.modes.active/commands/setMode',
            name: 'setMode',
            isExecutable: true,
            params: {
              mode: {
                type: 'string',
                required: true,
                constraints: {
                  enum: [
                    'standby',
                    'heating',
                    'dhw',
                    'dhwAndHeating',
                    'cooling',
                    'auto',
                    'dhwAndAuto',
                    'dhwAndCooling',
                  ],
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.modes.active',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.modes.active',
        timestamp: '2022-10-09T08:07:05.894Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.modes.dhwAndHeatingCooling',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.modes.dhwAndHeatingCooling',
        timestamp: '2022-10-09T08:06:57.841Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          entries: {
            type: 'array',
            value: [
              {
                priority: 'status',
                timestamp: '2022-10-03T09:17:20.000Z',
                accessLevel: 'customer',
                errorCode: 'S.165',
                audiences: [
                  'IS-SUPPLIER',
                  'IS-DEVELOPMENT',
                  'IS-MANUFACTURING',
                  'IS-AFTERSALES',
                  'IS-AFTERMARKET',
                  'IS-DEVELOPER-VEG',
                  'IS-BIG-DATA',
                  'IS-MANUFACTURING-VEG',
                ],
              },
              {
                priority: 'status',
                timestamp: '2022-10-03T09:17:13.000Z',
                accessLevel: 'customer',
                errorCode: 'S.117',
                audiences: [
                  'IS-SUPPLIER',
                  'IS-DEVELOPMENT',
                  'IS-MANUFACTURING',
                  'IS-AFTERSALES',
                  'IS-AFTERMARKET',
                  'IS-DEVELOPER-VEG',
                  'IS-BIG-DATA',
                  'IS-MANUFACTURING-VEG',
                ],
              },
              {
                priority: 'status',
                timestamp: '2022-10-03T09:17:07.000Z',
                accessLevel: 'customer',
                errorCode: 'S.123',
                audiences: [
                  'IS-SUPPLIER',
                  'IS-DEVELOPMENT',
                  'IS-MANUFACTURING',
                  'IS-AFTERSALES',
                  'IS-AFTERMARKET',
                  'IS-DEVELOPER-VEG',
                  'IS-BIG-DATA',
                  'IS-MANUFACTURING-VEG',
                ],
              },
              {
                priority: 'status',
                timestamp: '2022-10-03T09:17:04.000Z',
                accessLevel: 'customer',
                errorCode: 'S.120',
                audiences: [
                  'IS-SUPPLIER',
                  'IS-DEVELOPMENT',
                  'IS-MANUFACTURING',
                  'IS-AFTERSALES',
                  'IS-AFTERMARKET',
                  'IS-DEVELOPER-VEG',
                  'IS-BIG-DATA',
                  'IS-MANUFACTURING-VEG',
                ],
              },
              {
                priority: 'status',
                timestamp: '2022-10-03T09:17:04.000Z',
                accessLevel: 'customer',
                errorCode: 'S.219',
                audiences: [
                  'IS-SUPPLIER',
                  'IS-DEVELOPMENT',
                  'IS-MANUFACTURING',
                  'IS-AFTERSALES',
                  'IS-AFTERMARKET',
                  'IS-DEVELOPER-VEG',
                  'IS-BIG-DATA',
                  'IS-MANUFACTURING-VEG',
                ],
              },
              {
                priority: 'status',
                timestamp: '2022-10-03T09:17:04.000Z',
                accessLevel: 'customer',
                errorCode: 'S.218',
                audiences: [
                  'IS-SUPPLIER',
                  'IS-DEVELOPMENT',
                  'IS-MANUFACTURING',
                  'IS-AFTERSALES',
                  'IS-AFTERMARKET',
                  'IS-DEVELOPER-VEG',
                  'IS-BIG-DATA',
                  'IS-MANUFACTURING-VEG',
                ],
              },
              {
                priority: 'status',
                timestamp: '2022-10-03T09:17:04.000Z',
                accessLevel: 'customer',
                errorCode: 'S.217',
                audiences: [
                  'IS-SUPPLIER',
                  'IS-DEVELOPMENT',
                  'IS-MANUFACTURING',
                  'IS-AFTERSALES',
                  'IS-AFTERMARKET',
                  'IS-DEVELOPER-VEG',
                  'IS-BIG-DATA',
                  'IS-MANUFACTURING-VEG',
                ],
              },
              {
                priority: 'status',
                timestamp: '2022-10-03T09:17:04.000Z',
                accessLevel: 'customer',
                errorCode: 'S.165',
                audiences: [
                  'IS-SUPPLIER',
                  'IS-DEVELOPMENT',
                  'IS-MANUFACTURING',
                  'IS-AFTERSALES',
                  'IS-AFTERMARKET',
                  'IS-DEVELOPER-VEG',
                  'IS-BIG-DATA',
                  'IS-MANUFACTURING-VEG',
                ],
              },
            ],
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/device.messages.status.raw',
        gatewayId: gatewaySerial,
        feature: 'device.messages.status.raw',
        timestamp: '2022-10-10T10:11:38.864Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
          temperature: {
            value: 23,
            unit: 'celsius',
            type: 'number',
          },
          demand: {
            value: 'cooling',
            type: 'string',
          },
        },
        commands: {
          setTemperature: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1.operating.programs.reducedCooling/commands/setTemperature',
            name: 'setTemperature',
            isExecutable: true,
            params: {
              targetTemperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 12,
                  max: 30,
                  stepping: 1,
                },
              },
            },
          },
          activate: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1.operating.programs.reducedCooling/commands/activate',
            name: 'activate',
            isExecutable: false,
            params: {
              temperature: {
                type: 'number',
                required: false,
                constraints: {
                  min: 12,
                  max: 30,
                  stepping: 1,
                },
              },
            },
          },
          deactivate: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1.operating.programs.reducedCooling/commands/deactivate',
            name: 'deactivate',
            isExecutable: false,
            params: {},
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.programs.reducedCooling',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.programs.reducedCooling',
        timestamp: '2022-10-09T08:06:57.841Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 0,
            unit: '',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.spf.dhw',
        gatewayId: gatewaySerial,
        feature: 'heating.spf.dhw',
        timestamp: '2022-10-09T08:07:05.028Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          mode: {
            value: 'active',
            type: 'string',
          },
        },
        commands: {
          setMode: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.configuration.cooling/commands/setMode',
            name: 'setMode',
            isExecutable: false,
            params: {
              mode: {
                type: 'string',
                required: true,
                constraints: {
                  enum: ['none', 'active'],
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.configuration.cooling',
        gatewayId: gatewaySerial,
        feature: 'heating.configuration.cooling',
        timestamp: '2022-10-09T08:06:57.841Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          status: {
            type: 'string',
            value: 'connected',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/device.zigbee.status',
        gatewayId: gatewaySerial,
        feature: 'device.zigbee.status',
        timestamp: '2022-10-09T08:07:05.851Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.modes.dhwAndCooling',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.modes.dhwAndCooling',
        timestamp: '2022-10-09T08:06:57.841Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 39.3,
            unit: 'celsius',
          },
          status: {
            type: 'string',
            value: 'connected',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.compressors.0.sensors.temperature.oil',
        gatewayId: gatewaySerial,
        feature: 'heating.compressors.0.sensors.temperature.oil',
        timestamp: '2022-10-10T10:11:33.764Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'string',
            value: 'reducedCooling',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.programs.active',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.programs.active',
        timestamp: '2022-10-09T08:07:05.214Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.3.operating.programs.summerEco',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.3.operating.programs.summerEco',
        timestamp: '2022-10-09T08:07:06.276Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 0,
            unit: '',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.seer.cooling',
        gatewayId: gatewaySerial,
        feature: 'heating.seer.cooling',
        timestamp: '2022-10-09T08:07:05.096Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'string',
            value: '7720518000000000',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.boiler.serial',
        gatewayId: gatewaySerial,
        feature: 'heating.boiler.serial',
        timestamp: '2022-10-09T08:07:06.337Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          status: {
            type: 'string',
            value: 'on',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.boiler.pumps.internal',
        gatewayId: gatewaySerial,
        feature: 'heating.boiler.pumps.internal',
        timestamp: '2022-10-09T08:07:06.296Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
          name: {
            value: '',
            type: 'string',
          },
          type: {
            value: 'heatingCircuit',
            type: 'string',
          },
        },
        commands: {
          setName: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1/commands/setName',
            name: 'setName',
            isExecutable: true,
            params: {
              name: {
                type: 'string',
                required: true,
                constraints: {
                  minLength: 1,
                  maxLength: 20,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1',
        timestamp: '2022-10-09T08:06:57.841Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {},
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.pumps.primary',
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.pumps.primary',
        timestamp: '2022-10-09T08:07:06.012Z',
        isEnabled: true,
        isReady: false,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 24.3,
            unit: 'celsius',
          },
          status: {
            type: 'string',
            value: 'connected',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.secondaryCircuit.sensors.temperature.supply',
        gatewayId: gatewaySerial,
        feature: 'heating.secondaryCircuit.sensors.temperature.supply',
        timestamp: '2022-10-10T10:11:30.755Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.compressors.0.heater.crankcase',
        gatewayId: gatewaySerial,
        feature: 'heating.compressors.0.heater.crankcase',
        timestamp: '2022-10-09T08:07:03.838Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.modes.dhwAndTestMode',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.modes.dhwAndTestMode',
        timestamp: '2022-10-09T08:06:57.841Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          status: {
            type: 'string',
            value: 'connected',
          },
          value: {
            type: 'number',
            value: 0,
            unit: 'watt',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.heatingRod.power.consumption.current',
        gatewayId: gatewaySerial,
        feature: 'heating.heatingRod.power.consumption.current',
        timestamp: '2022-10-09T08:07:05.029Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 0,
            unit: 'kilowatt',
          },
          status: {
            type: 'string',
            value: 'connected',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.power.consumption.current',
        gatewayId: gatewaySerial,
        feature: 'heating.power.consumption.current',
        timestamp: '2022-10-09T08:07:05.046Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          entries: {
            type: 'array',
            value: [
              {
                priority: 'info',
                timestamp: '2022-10-03T09:17:04.000Z',
                accessLevel: 'customer',
                errorCode: 'I.114',
                audiences: [
                  'IS-SUPPLIER',
                  'IS-DEVELOPMENT',
                  'IS-MANUFACTURING',
                  'IS-AFTERSALES',
                  'IS-AFTERMARKET',
                  'IS-DEVELOPER-VEG',
                  'IS-BIG-DATA',
                  'IS-MANUFACTURING-VEG',
                ],
              },
            ],
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/device.messages.info.raw',
        gatewayId: gatewaySerial,
        feature: 'device.messages.info.raw',
        timestamp: '2022-10-09T08:07:06.327Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          day: {
            type: 'array',
            value: [2.5, 3.1, 4.5, 4.3, 4.3, 4.7, 4.2, 4.3],
            unit: 'kilowattHour',
          },
          week: {
            type: 'array',
            value: [10.1, 30.7, 30.5, 30.1, 32.5, 20.3],
            unit: 'kilowattHour',
          },
          month: {
            type: 'array',
            value: [27.6, 126.6, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            unit: 'kilowattHour',
          },
          year: {
            type: 'array',
            value: [154.2, 0],
            unit: 'kilowattHour',
          },
          dayValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          weekValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          monthValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          yearValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.compressors.0.power.consumption.dhw',
        gatewayId: gatewaySerial,
        feature: 'heating.compressors.0.power.consumption.dhw',
        timestamp: '2022-10-09T22:01:47.242Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          day: {
            type: 'array',
            value: [0, 0, 0, 0, 0, 0, 0, 0],
            unit: 'kilowattHour',
          },
          week: {
            type: 'array',
            value: [0, 0, 0, 0, 0, 0],
            unit: 'kilowattHour',
          },
          month: {
            type: 'array',
            value: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            unit: 'kilowattHour',
          },
          year: {
            type: 'array',
            value: [0, 0],
            unit: 'kilowattHour',
          },
          dayValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          weekValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          monthValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          yearValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.heatingRod.power.consumption.dhw',
        gatewayId: gatewaySerial,
        feature: 'heating.heatingRod.power.consumption.dhw',
        timestamp: '2022-10-09T22:01:47.242Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          day: {
            type: 'array',
            value: [1.4, 1.4, 2.7, 2.9, 2.8, 2.2, 1.9, 2.4],
            unit: 'kilowattHour',
          },
          week: {
            type: 'array',
            value: [5.5, 17, 18.29, 24.3, 19.92, 19.3],
            unit: 'kilowattHour',
          },
          month: {
            type: 'array',
            value: [15.3, 89, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            unit: 'kilowattHour',
          },
          year: {
            type: 'array',
            value: [104.3, 0],
            unit: 'kilowattHour',
          },
          dayValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          weekValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          monthValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          yearValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.compressors.0.power.consumption.heating',
        gatewayId: gatewaySerial,
        feature: 'heating.compressors.0.power.consumption.heating',
        timestamp: '2022-10-09T22:01:47.242Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          day: {
            type: 'array',
            value: [0, 0, 0, 0, 0, 0, 0, 0],
            unit: 'kilowattHour',
          },
          week: {
            type: 'array',
            value: [0, 0, 0, 0, 0, 0],
            unit: 'kilowattHour',
          },
          month: {
            type: 'array',
            value: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            unit: 'kilowattHour',
          },
          year: {
            type: 'array',
            value: [0, 0],
            unit: 'kilowattHour',
          },
          dayValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          weekValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          monthValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          yearValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.heatingRod.power.consumption.heating',
        gatewayId: gatewaySerial,
        feature: 'heating.heatingRod.power.consumption.heating',
        timestamp: '2022-10-09T22:01:47.242Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          day: {
            type: 'array',
            value: [0, 0, 0, 0, 0, 0, 0, 0],
            unit: 'kilowattHour',
          },
          week: {
            type: 'array',
            value: [0, 0, 0, 0, 0, 0],
            unit: 'kilowattHour',
          },
          month: {
            type: 'array',
            value: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            unit: 'kilowattHour',
          },
          year: {
            type: 'array',
            value: [0, 0],
            unit: 'kilowattHour',
          },
          dayValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          weekValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          monthValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
          yearValueReadAt: {
            type: 'string',
            value: dayjs().format('YYYY-MM-DDT12:00:00[Z]'),
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.power.consumption.cooling',
        gatewayId: gatewaySerial,
        feature: 'heating.power.consumption.cooling',
        timestamp: '2022-10-09T22:01:47.242Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          entries: {
            type: 'ErrorListChanges',
            constraints: {},
            value: {
              new: [],
              current: [],
              gone: [],
            },
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/device.messages.warnings.active',
        gatewayId: gatewaySerial,
        feature: 'device.messages.warnings.active',
        timestamp: '2022-10-05T20:51:02.266Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          entries: {
            value: {
              mon: [
                {
                  mode: 'on',
                  start: '05:30',
                  end: '22:00',
                  position: 0,
                },
              ],
              tue: [
                {
                  mode: 'on',
                  start: '05:30',
                  end: '22:00',
                  position: 0,
                },
              ],
              wed: [
                {
                  mode: 'on',
                  start: '05:30',
                  end: '22:00',
                  position: 0,
                },
              ],
              thu: [
                {
                  mode: 'on',
                  start: '05:30',
                  end: '22:00',
                  position: 0,
                },
              ],
              fri: [
                {
                  mode: 'on',
                  start: '05:30',
                  end: '22:00',
                  position: 0,
                },
              ],
              sat: [
                {
                  mode: 'on',
                  start: '05:30',
                  end: '22:00',
                  position: 0,
                },
              ],
              sun: [
                {
                  mode: 'on',
                  start: '05:30',
                  end: '22:00',
                  position: 0,
                },
              ],
            },
            type: 'Schedule',
          },
        },
        commands: {
          setSchedule: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.dhw.schedule/commands/setSchedule',
            name: 'setSchedule',
            isExecutable: true,
            params: {
              newSchedule: {
                type: 'Schedule',
                required: true,
                constraints: {
                  modes: ['on'],
                  maxEntries: 4,
                  resolution: 10,
                  defaultMode: 'off',
                  overlapAllowed: false,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.schedule',
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.schedule',
        timestamp: '2022-10-09T08:06:57.841Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          min: {
            type: 'number',
            value: 10,
            unit: 'celsius',
          },
          max: {
            type: 'number',
            value: 10,
            unit: 'celsius',
          },
          default: {
            type: 'number',
            value: 50,
            unit: 'celsius',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.temperature.levels',
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.temperature.levels',
        timestamp: '2022-10-09T08:07:06.217Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          temperature: {
            value: 7,
            unit: 'celsius',
            type: 'number',
          },
          demand: {
            value: 'heating',
            type: 'string',
          },
        },
        commands: {
          setTemperature: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1.operating.programs.reducedHeating/commands/setTemperature',
            name: 'setTemperature',
            isExecutable: true,
            params: {
              targetTemperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 3,
                  max: 22,
                  stepping: 1,
                },
              },
            },
          },
          activate: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1.operating.programs.reducedHeating/commands/activate',
            name: 'activate',
            isExecutable: false,
            params: {
              temperature: {
                type: 'number',
                required: false,
                constraints: {
                  min: 3,
                  max: 22,
                  stepping: 1,
                },
              },
            },
          },
          deactivate: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1.operating.programs.reducedHeating/commands/deactivate',
            name: 'deactivate',
            isExecutable: false,
            params: {},
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.programs.reducedHeating',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.programs.reducedHeating',
        timestamp: '2022-10-09T08:06:57.841Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          mode: {
            type: 'string',
            value: 'WeatherByOutsideSensorControlled',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.2.regulation',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.2.regulation',
        timestamp: '2022-10-09T08:07:06.270Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          status: {
            type: 'string',
            value: 'notConnected',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.compressors.0.sensors.temperature.motorChamber',
        gatewayId: gatewaySerial,
        feature: 'heating.compressors.0.sensors.temperature.motorChamber',
        timestamp: '2022-10-09T08:07:05.169Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: true,
            type: 'boolean',
          },
          status: {
            value: 'off',
            type: 'string',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw',
        gatewayId: gatewaySerial,
        feature: 'heating.dhw',
        timestamp: '2022-10-09T08:06:57.841Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          enabled: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {
          activate: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.dhw.hygiene/commands/activate',
            name: 'activate',
            isExecutable: false,
            params: {},
          },
          enable: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.dhw.hygiene/commands/enable',
            name: 'enable',
            isExecutable: true,
            params: {},
          },
          disable: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.dhw.hygiene/commands/disable',
            name: 'disable',
            isExecutable: false,
            params: {},
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.hygiene',
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.hygiene',
        timestamp: '2022-10-09T08:06:57.841Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 0,
            unit: 'rotations/second',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.compressors.0.speed.current',
        gatewayId: gatewaySerial,
        feature: 'heating.compressors.0.speed.current',
        timestamp: '2022-10-09T08:07:05.171Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.operating.modes.eco',
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.operating.modes.eco',
        timestamp: '2022-10-09T08:07:05.198Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.programs.standby',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.programs.standby',
        timestamp: '2022-10-09T08:06:57.841Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          status: {
            type: 'string',
            value: 'off',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.frostprotection',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.frostprotection',
        timestamp: '2022-10-09T08:07:06.222Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 0,
            unit: 'liter',
          },
        },
        commands: {
          setValue: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.configuration.centralHeatingCylinderSize/commands/setValue',
            name: 'setValue',
            isExecutable: true,
            params: {
              value: {
                required: true,
                constraints: {
                  min: 0,
                  max: 6553.5,
                  stepping: 0.1,
                },
                type: 'number',
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.configuration.centralHeatingCylinderSize',
        gatewayId: gatewaySerial,
        feature: 'heating.configuration.centralHeatingCylinderSize',
        timestamp: '2022-10-09T08:07:06.202Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 15.8,
            unit: 'celsius',
          },
          status: {
            type: 'string',
            value: 'connected',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.evaporators.0.sensors.temperature.overheat',
        gatewayId: gatewaySerial,
        feature: 'heating.evaporators.0.sensors.temperature.overheat',
        timestamp: '2022-10-10T10:11:46.920Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            unit: 'bar',
            value: 1.6,
            type: 'number',
          },
          status: {
            value: 'connected',
            type: 'string',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.sensors.pressure.supply',
        gatewayId: gatewaySerial,
        feature: 'heating.sensors.pressure.supply',
        timestamp: '2022-10-09T08:06:57.841Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          entries: {
            type: 'ErrorListChanges',
            constraints: {},
            value: {
              new: [],
              current: [
                {
                  priority: 'criticalError',
                  timestamp: '2022-10-03T07:20:53.897Z',
                  accessLevel: 'customer',
                  errorCode: 'F.520',
                  audiences: [
                    'IS-SUPPLIER',
                    'IS-DEVELOPMENT',
                    'IS-MANUFACTURING',
                    'IS-AFTERSALES',
                    'IS-AFTERMARKET',
                    'IS-DEVELOPER-VEG',
                    'IS-BIG-DATA',
                    'IS-MANUFACTURING-VEG',
                  ],
                },
                {
                  priority: 'criticalError',
                  timestamp: '2022-10-03T07:20:53.897Z',
                  accessLevel: 'customer',
                  errorCode: 'F.875',
                  audiences: [
                    'IS-SUPPLIER',
                    'IS-DEVELOPMENT',
                    'IS-MANUFACTURING',
                    'IS-AFTERSALES',
                    'IS-AFTERMARKET',
                    'IS-DEVELOPER-VEG',
                    'IS-BIG-DATA',
                    'IS-MANUFACTURING-VEG',
                  ],
                },
                {
                  priority: 'criticalError',
                  timestamp: '2022-10-03T07:20:53.897Z',
                  accessLevel: 'customer',
                  errorCode: 'F.1034',
                  audiences: [
                    'IS-SUPPLIER',
                    'IS-DEVELOPMENT',
                    'IS-MANUFACTURING',
                    'IS-AFTERSALES',
                    'IS-AFTERMARKET',
                    'IS-DEVELOPER-VEG',
                    'IS-BIG-DATA',
                    'IS-MANUFACTURING-VEG',
                  ],
                },
              ],
              gone: [],
            },
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.errors.active',
        gatewayId: gatewaySerial,
        feature: 'heating.errors.active',
        timestamp: '2022-10-07T18:18:06.297Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 5,
            unit: 'celsius',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.secondaryCircuit.temperature.return.minimum',
        gatewayId: gatewaySerial,
        feature: 'heating.secondaryCircuit.temperature.return.minimum',
        timestamp: '2022-10-09T08:07:03.831Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.3.zone.mode',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.3.zone.mode',
        timestamp: '2022-10-09T08:07:06.237Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.modes.heatingCooling',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.modes.heatingCooling',
        timestamp: '2022-10-09T08:06:57.841Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          reason: {
            value: 'unknown',
            type: 'string',
          },
          demand: {
            value: 'heating',
            type: 'string',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.programs.reducedEnergySaving',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.programs.reducedEnergySaving',
        timestamp: '2022-10-09T08:06:57.841Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 38.1,
            unit: 'celsius',
          },
          status: {
            type: 'string',
            value: 'connected',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.sensors.temperature.outside',
        gatewayId: gatewaySerial,
        feature: 'heating.sensors.temperature.outside',
        timestamp: '2022-10-10T09:21:46.931Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'string',
            value: '7720518000000000',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/device.serial',
        gatewayId: gatewaySerial,
        feature: 'device.serial',
        timestamp: '2022-10-09T08:07:05.850Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          start: {
            value: '2000-01-01',
            type: 'string',
          },
          end: {
            value: '2000-01-01',
            type: 'string',
          },
        },
        commands: {
          changeEndDate: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.operating.programs.holiday/commands/changeEndDate',
            name: 'changeEndDate',
            isExecutable: false,
            params: {
              end: {
                type: 'string',
                required: true,
                constraints: {
                  regEx: '^[\\d]{4}-[\\d]{2}-[\\d]{2}$',
                  sameDayAllowed: true,
                },
              },
            },
          },
          schedule: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.operating.programs.holiday/commands/schedule',
            name: 'schedule',
            isExecutable: true,
            params: {
              start: {
                type: 'string',
                required: true,
                constraints: {
                  regEx: '^[\\d]{4}-[\\d]{2}-[\\d]{2}$',
                },
              },
              end: {
                type: 'string',
                required: true,
                constraints: {
                  regEx: '^[\\d]{4}-[\\d]{2}-[\\d]{2}$',
                  sameDayAllowed: true,
                },
              },
            },
          },
          unschedule: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.operating.programs.holiday/commands/unschedule',
            name: 'unschedule',
            isExecutable: true,
            params: {},
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.operating.programs.holiday',
        gatewayId: gatewaySerial,
        feature: 'heating.operating.programs.holiday',
        timestamp: '2022-10-09T08:06:57.841Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          status: {
            type: 'string',
            value: 'connected',
          },
          value: {
            type: 'number',
            value: 50.2,
            unit: 'celsius',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.compressors.0.sensors.temperature.outlet',
        gatewayId: gatewaySerial,
        feature: 'heating.compressors.0.sensors.temperature.outlet',
        timestamp: '2022-10-10T10:11:43.903Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          currentDay: {
            type: 'number',
            value: 0,
            unit: 'kilowattHour',
          },
          lastSevenDays: {
            type: 'number',
            value: 0,
            unit: 'kilowattHour',
          },
          currentMonth: {
            type: 'number',
            value: 0,
            unit: 'kilowattHour',
          },
          lastMonth: {
            type: 'number',
            value: 0,
            unit: 'kilowattHour',
          },
          currentYear: {
            type: 'number',
            value: 0,
            unit: 'kilowattHour',
          },
          lastYear: {
            type: 'number',
            value: 0,
            unit: 'kilowattHour',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.power.consumption.summary.dhw',
        gatewayId: gatewaySerial,
        feature: 'heating.power.consumption.summary.dhw',
        timestamp: '2022-10-09T08:07:06.295Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {
          activate: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.dhw.oneTimeCharge/commands/activate',
            name: 'activate',
            isExecutable: true,
            params: {},
          },
          deactivate: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.dhw.oneTimeCharge/commands/deactivate',
            name: 'deactivate',
            isExecutable: false,
            params: {},
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.oneTimeCharge',
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.oneTimeCharge',
        timestamp: '2022-10-09T08:06:57.841Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 38.9,
            unit: 'celsius',
          },
          status: {
            type: 'string',
            value: 'connected',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.boiler.sensors.temperature.commonSupply',
        gatewayId: gatewaySerial,
        feature: 'heating.boiler.sensors.temperature.commonSupply',
        timestamp: '2022-10-09T08:07:05.987Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          reason: {
            value: 'summerEco',
            type: 'string',
          },
          demand: {
            value: 'cooling',
            type: 'string',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.programs.reducedCoolingEnergySaving',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.programs.reducedCoolingEnergySaving',
        timestamp: '2022-10-09T08:06:57.841Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 34,
            unit: 'celsius',
          },
          status: {
            type: 'string',
            value: 'connected',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.sensors.temperature.return',
        gatewayId: gatewaySerial,
        feature: 'heating.sensors.temperature.return',
        timestamp: '2022-10-10T10:06:32.229Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            value: 44,
            unit: 'celsius',
            type: 'number',
          },
        },
        commands: {
          setTargetTemperature: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.dhw.temperature.main/commands/setTargetTemperature',
            name: 'setTargetTemperature',
            isExecutable: true,
            params: {
              temperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 10,
                  efficientLowerBorder: 0,
                  efficientUpperBorder: 55,
                  max: 60,
                  stepping: 1,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.temperature.main',
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.temperature.main',
        timestamp: '2022-10-09T08:06:57.841Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            value: 'off',
            type: 'string',
          },
        },
        commands: {
          setMode: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.dhw.operating.modes.active/commands/setMode',
            name: 'setMode',
            isExecutable: true,
            params: {
              mode: {
                type: 'string',
                required: true,
                constraints: {
                  enum: ['off', 'comfort', 'eco'],
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.operating.modes.active',
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.operating.modes.active',
        timestamp: '2022-10-09T08:07:05.200Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            value: 10,
            unit: 'kelvin',
            type: 'number',
          },
          switchOnValue: {
            value: 10,
            unit: 'kelvin',
            type: 'number',
          },
          switchOffValue: {
            value: 2,
            unit: 'kelvin',
            type: 'number',
          },
        },
        commands: {
          setHysteresis: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.dhw.temperature.hysteresis/commands/setHysteresis',
            name: 'setHysteresis',
            isExecutable: true,
            params: {
              hysteresis: {
                type: 'number',
                required: true,
                constraints: {
                  min: 1,
                  max: 10,
                  stepping: 0.5,
                },
              },
            },
          },
          setHysteresisSwitchOnValue: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.dhw.temperature.hysteresis/commands/setHysteresisSwitchOnValue',
            name: 'setHysteresisSwitchOnValue',
            isExecutable: true,
            params: {
              hysteresis: {
                type: 'number',
                required: true,
                constraints: {
                  min: 1,
                  max: 10,
                  stepping: 0.5,
                },
              },
            },
          },
          setHysteresisSwitchOffValue: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.dhw.temperature.hysteresis/commands/setHysteresisSwitchOffValue',
            name: 'setHysteresisSwitchOffValue',
            isExecutable: true,
            params: {
              hysteresis: {
                type: 'number',
                required: true,
                constraints: {
                  min: 0,
                  max: 2.5,
                  stepping: 0.5,
                },
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.temperature.hysteresis',
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.temperature.hysteresis',
        timestamp: '2022-10-09T08:06:57.841Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 6.53,
            unit: 'bar',
          },
          status: {
            type: 'string',
            value: 'connected',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.compressors.0.sensors.pressure.inlet',
        gatewayId: gatewaySerial,
        feature: 'heating.compressors.0.sensors.pressure.inlet',
        timestamp: '2022-10-10T10:04:59.248Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          status: {
            type: 'string',
            value: 'off',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.circulation.pump',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.circulation.pump',
        timestamp: '2022-10-09T08:07:06.244Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.modes.standby',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.modes.standby',
        timestamp: '2022-10-09T08:06:57.841Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.programs.fixed',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.programs.fixed',
        timestamp: '2022-10-09T08:07:03.994Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          phase: {
            value: 'off',
            type: 'string',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.compressors.0',
        gatewayId: gatewaySerial,
        feature: 'heating.compressors.0',
        timestamp: '2022-10-09T08:06:57.841Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          reason: {
            value: 'unknown',
            type: 'string',
          },
          demand: {
            value: 'heating',
            type: 'string',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.3.operating.programs.reducedEnergySaving',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.3.operating.programs.reducedEnergySaving',
        timestamp: '2022-10-09T08:06:57.841Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 0,
            unit: 'kilowatt',
          },
          status: {
            type: 'string',
            value: 'connected',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.heat.production.current',
        gatewayId: gatewaySerial,
        feature: 'heating.heat.production.current',
        timestamp: '2022-10-09T08:07:05.062Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 39.1,
            unit: 'celsius',
          },
          status: {
            type: 'string',
            value: 'connected',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.sensors.temperature.supply',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.sensors.temperature.supply',
        timestamp: '2022-10-09T08:07:06.249Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          useApproved: {
            value: true,
            type: 'boolean',
          },
        },
        commands: {
          grant: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.configuration.heatingRod.heating/commands/grant',
            name: 'grant',
            isExecutable: false,
            params: {},
          },
          revoke: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.configuration.heatingRod.heating/commands/revoke',
            name: 'revoke',
            isExecutable: true,
            params: {},
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.configuration.heatingRod.heating',
        gatewayId: gatewaySerial,
        feature: 'heating.configuration.heatingRod.heating',
        timestamp: '2022-10-09T08:06:57.841Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.configuration.multiFamilyHouse',
        gatewayId: gatewaySerial,
        feature: 'heating.configuration.multiFamilyHouse',
        timestamp: '2022-10-09T08:06:57.841Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          horizontal: {
            type: 'number',
            value: 0,
            unit: 'degree',
          },
          vertical: {
            type: 'number',
            value: 0,
            unit: 'degree',
          },
        },
        commands: {
          setOrientation: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.configuration.houseOrientation/commands/setOrientation',
            name: 'setOrientation',
            isExecutable: true,
            params: {
              horizontal: {
                required: true,
                constraints: {
                  min: 0,
                  max: 360,
                  stepping: 1,
                },
                type: 'number',
              },
              vertical: {
                required: true,
                constraints: {
                  min: 0,
                  max: 360,
                  stepping: 1,
                },
                type: 'number',
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.configuration.houseOrientation',
        gatewayId: gatewaySerial,
        feature: 'heating.configuration.houseOrientation',
        timestamp: '2022-10-09T08:07:06.207Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          starts: {
            type: 'number',
            value: 0,
            unit: '',
          },
          hours: {
            type: 'number',
            value: 0,
            unit: 'hour',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.compressors.0.statistics',
        gatewayId: gatewaySerial,
        feature: 'heating.compressors.0.statistics',
        timestamp: '2022-10-09T08:07:05.039Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.programs.summerEco',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.programs.summerEco',
        timestamp: '2022-10-09T08:07:06.274Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          enabled: {
            type: 'array',
            value: ['0', '1'],
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.primaryCircuit.fans',
        gatewayId: gatewaySerial,
        feature: 'heating.primaryCircuit.fans',
        timestamp: '2022-10-09T08:07:03.824Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.2.zone.mode',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.2.zone.mode',
        timestamp: '2022-10-09T08:07:06.236Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.primaryCircuit.valves.fourWay',
        gatewayId: gatewaySerial,
        feature: 'heating.primaryCircuit.valves.fourWay',
        timestamp: '2022-10-09T08:07:03.823Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.programs.frostprotection',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.programs.frostprotection',
        timestamp: '2022-10-09T08:07:03.989Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          enabled: {
            value: ['0', '1'],
            type: 'array',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits',
        timestamp: '2022-10-09T08:06:57.841Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          status: {
            type: 'string',
            value: 'connected',
          },
          value: {
            type: 'number',
            value: 50,
            unit: 'percent',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.sensors.valve.0.expansion',
        gatewayId: gatewaySerial,
        feature: 'heating.sensors.valve.0.expansion',
        timestamp: '2022-10-09T08:07:03.815Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          entries: {
            type: 'array',
            value: [],
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/device.messages.service.raw',
        gatewayId: gatewaySerial,
        feature: 'device.messages.service.raw',
        timestamp: '2022-10-09T08:07:06.332Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          temperature: {
            value: 9,
            unit: 'celsius',
            type: 'number',
          },
          demand: {
            value: 'heating',
            type: 'string',
          },
        },
        commands: {
          setTemperature: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1.operating.programs.normalHeating/commands/setTemperature',
            name: 'setTemperature',
            isExecutable: true,
            params: {
              targetTemperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 3,
                  max: 22,
                  stepping: 1,
                },
              },
            },
          },
          activate: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1.operating.programs.normalHeating/commands/activate',
            name: 'activate',
            isExecutable: false,
            params: {
              temperature: {
                type: 'number',
                required: false,
                constraints: {
                  min: 3,
                  max: 22,
                  stepping: 1,
                },
              },
            },
          },
          deactivate: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1.operating.programs.normalHeating/commands/deactivate',
            name: 'deactivate',
            isExecutable: false,
            params: {},
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.programs.normalHeating',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.programs.normalHeating',
        timestamp: '2022-10-09T08:06:57.841Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          reason: {
            value: 'summerEco',
            type: 'string',
          },
          demand: {
            value: 'cooling',
            type: 'string',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.programs.normalCoolingEnergySaving',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.programs.normalCoolingEnergySaving',
        timestamp: '2022-10-09T08:06:57.841Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 0,
            unit: 'percent',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.primaryCircuit.fans.1.current',
        gatewayId: gatewaySerial,
        feature: 'heating.primaryCircuit.fans.1.current',
        timestamp: '2022-10-09T08:07:03.826Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.operating.modes.comfort',
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.operating.modes.comfort',
        timestamp: '2022-10-09T08:07:05.197Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 0.3,
            unit: '',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.spf.heating',
        gatewayId: gatewaySerial,
        feature: 'heating.spf.heating',
        timestamp: '2022-10-09T08:07:03.972Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 39.3,
            unit: 'celsius',
          },
          status: {
            type: 'string',
            value: 'connected',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.evaporators.0.sensors.temperature.liquid',
        gatewayId: gatewaySerial,
        feature: 'heating.evaporators.0.sensors.temperature.liquid',
        timestamp: '2022-10-10T10:11:38.847Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.modes.dhwAndAuto',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.modes.dhwAndAuto',
        timestamp: '2022-10-09T08:06:57.841Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: true,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.dhw.operating.modes.off',
        gatewayId: gatewaySerial,
        feature: 'heating.dhw.operating.modes.off',
        timestamp: '2022-10-09T08:07:05.201Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          temperature: {
            value: 9,
            unit: 'celsius',
            type: 'number',
          },
          demand: {
            value: 'heating',
            type: 'string',
          },
        },
        commands: {
          setTemperature: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1.operating.programs.comfortHeating/commands/setTemperature',
            name: 'setTemperature',
            isExecutable: true,
            params: {
              targetTemperature: {
                type: 'number',
                required: true,
                constraints: {
                  min: 3,
                  max: 22,
                  stepping: 1,
                },
              },
            },
          },
          activate: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1.operating.programs.comfortHeating/commands/activate',
            name: 'activate',
            isExecutable: false,
            params: {
              temperature: {
                type: 'number',
                required: false,
                constraints: {
                  min: 3,
                  max: 22,
                  stepping: 1,
                },
              },
            },
          },
          deactivate: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1.operating.programs.comfortHeating/commands/deactivate',
            name: 'deactivate',
            isExecutable: false,
            params: {},
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.programs.comfortHeating',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.programs.comfortHeating',
        timestamp: '2022-10-09T08:06:57.841Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          latitude: {
            type: 'number',
            value: 0,
            unit: 'degree',
          },
          longitude: {
            type: 'number',
            value: 0,
            unit: 'degree',
          },
          altitude: {
            type: 'number',
            value: 0,
            unit: 'meter',
          },
        },
        commands: {
          setLocation: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.configuration.houseLocation/commands/setLocation',
            name: 'setLocation',
            isExecutable: true,
            params: {
              latitude: {
                required: true,
                constraints: {
                  min: -90,
                  max: 90,
                  stepping: 0.0001,
                },
                type: 'number',
              },
              longitude: {
                required: true,
                constraints: {
                  min: -180,
                  max: 180,
                  stepping: 0.0001,
                },
                type: 'number',
              },
              altitude: {
                required: true,
                constraints: {
                  min: 0,
                  max: 8848,
                  stepping: 1,
                },
                type: 'number',
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.configuration.houseLocation',
        gatewayId: gatewaySerial,
        feature: 'heating.configuration.houseLocation',
        timestamp: '2022-10-09T08:07:06.206Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.modes.dhw',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.modes.dhw',
        timestamp: '2022-10-09T08:06:57.841Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 8,
            unit: '',
          },
        },
        commands: {
          setValue: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.2.heating.roomInfluenceFactor/commands/setValue',
            name: 'setValue',
            isExecutable: true,
            params: {
              value: {
                required: true,
                constraints: {
                  min: 0,
                  max: 64,
                  stepping: 1,
                },
                type: 'number',
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.2.heating.roomInfluenceFactor',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.2.heating.roomInfluenceFactor',
        timestamp: '2022-10-09T08:07:06.280Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          reason: {
            value: 'summerEco',
            type: 'string',
          },
          demand: {
            value: 'heating',
            type: 'string',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.operating.programs.comfortEnergySaving',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.1.operating.programs.comfortEnergySaving',
        timestamp: '2022-10-09T08:06:57.841Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          currentDay: {
            type: 'number',
            value: 0,
            unit: 'kilowattHour',
          },
          lastSevenDays: {
            type: 'number',
            value: 0,
            unit: 'kilowattHour',
          },
          currentMonth: {
            type: 'number',
            value: 0,
            unit: 'kilowattHour',
          },
          lastMonth: {
            type: 'number',
            value: 0,
            unit: 'kilowattHour',
          },
          currentYear: {
            type: 'number',
            value: 15.2,
            unit: 'kilowattHour',
          },
          lastYear: {
            type: 'number',
            value: 0,
            unit: 'kilowattHour',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.power.consumption.summary.heating',
        gatewayId: gatewaySerial,
        feature: 'heating.power.consumption.summary.heating',
        timestamp: '2022-10-09T08:07:06.294Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            unit: 'minute',
            value: 119,
            type: 'number',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.device.time.offset',
        gatewayId: gatewaySerial,
        feature: 'heating.device.time.offset',
        timestamp: '2022-10-09T08:06:57.841Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 0,
            unit: 'liter',
          },
        },
        commands: {
          setValue: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.configuration.dhwCylinderSize/commands/setValue',
            name: 'setValue',
            isExecutable: true,
            params: {
              value: {
                required: true,
                constraints: {
                  min: 0,
                  max: 6553.5,
                  stepping: 0.1,
                },
                type: 'number',
              },
            },
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.configuration.dhwCylinderSize',
        gatewayId: gatewaySerial,
        feature: 'heating.configuration.dhwCylinderSize',
        timestamp: '2022-10-09T08:07:06.201Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          value: {
            type: 'number',
            value: 0,
            unit: 'percent',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.primaryCircuit.fans.0.current',
        gatewayId: gatewaySerial,
        feature: 'heating.primaryCircuit.fans.0.current',
        timestamp: '2022-10-09T08:07:03.825Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            type: 'boolean',
            value: false,
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.2.operating.programs.summerEco',
        gatewayId: gatewaySerial,
        feature: 'heating.circuits.2.operating.programs.summerEco',
        timestamp: '2022-10-09T08:07:06.275Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          currentDay: {
            type: 'number',
            value: 0,
            unit: 'kilowattHour',
          },
          lastSevenDays: {
            type: 'number',
            value: 0,
            unit: 'kilowattHour',
          },
          currentMonth: {
            type: 'number',
            value: 0,
            unit: 'kilowattHour',
          },
          lastMonth: {
            type: 'number',
            value: 0,
            unit: 'kilowattHour',
          },
          currentYear: {
            type: 'number',
            value: 8.2,
            unit: 'kilowattHour',
          },
          lastYear: {
            type: 'number',
            value: 0,
            unit: 'kilowattHour',
          },
        },
        commands: {},
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.heat.production.summary.heating',
        gatewayId: gatewaySerial,
        feature: 'heating.heat.production.summary.heating',
        timestamp: '2022-10-09T08:07:06.291Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        properties: {
          active: {
            value: false,
            type: 'boolean',
          },
          start: {
            value: '2000-01-01',
            type: 'string',
          },
          end: {
            value: '2000-01-01',
            type: 'string',
          },
        },
        commands: {
          changeEndDate: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.operating.programs.holidayAtHome/commands/changeEndDate',
            name: 'changeEndDate',
            isExecutable: false,
            params: {
              end: {
                type: 'string',
                required: true,
                constraints: {
                  regEx: '^[\\d]{4}-[\\d]{2}-[\\d]{2}$',
                  sameDayAllowed: true,
                },
              },
            },
          },
          schedule: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.operating.programs.holidayAtHome/commands/schedule',
            name: 'schedule',
            isExecutable: true,
            params: {
              start: {
                type: 'string',
                required: true,
                constraints: {
                  regEx: '^[\\d]{4}-[\\d]{2}-[\\d]{2}$',
                },
              },
              end: {
                type: 'string',
                required: true,
                constraints: {
                  regEx: '^[\\d]{4}-[\\d]{2}-[\\d]{2}$',
                  sameDayAllowed: true,
                },
              },
            },
          },
          unschedule: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.operating.programs.holidayAtHome/commands/unschedule',
            name: 'unschedule',
            isExecutable: true,
            params: {},
          },
        },
        apiVersion: 1,
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.operating.programs.holidayAtHome',
        gatewayId: gatewaySerial,
        feature: 'heating.operating.programs.holidayAtHome',
        timestamp: '2022-10-09T08:06:57.841Z',
        isEnabled: true,
        isReady: true,
        deviceId: '0',
      },
      {
        apiVersion: 1,
        isEnabled: true,
        isReady: true,
        timestamp: '2022-10-09T08:06:57.841Z',
        uri:
          'https://api-integration.viessmann-climatesolutions.com/iot/v2/features/installations/' +
          installationId +
          '/gateways/' +
          gatewaySerial +
          '/devices/0/features/heating.circuits.1.name',
        feature: 'heating.circuits.1.name',
        deviceId: '0',
        gatewayId: gatewaySerial,
        commands: {
          setName: {
            uri:
              'https://api-integration.viessmann-climatesolutions.com/iot/v1/equipment/installations/' +
              installationId +
              '/gateways/' +
              gatewaySerial +
              '/devices/0/features/heating.circuits.1.name/commands/setName',
            name: 'setName',
            isExecutable: true,
            params: {
              name: {
                type: 'string',
                required: true,
                constraints: {
                  minLength: 1,
                  maxLength: 20,
                },
              },
            },
          },
        },
        properties: {
          name: {
            type: 'string',
            value: '',
          },
        },
      },
    ];
  }
}
